
import BuscaClienteContato from "@/modules/CRM/components/BuscaClienteContato";
import CrmEmptyState from "@/modules/CRM/components/CrmEmptyState";
import CrmPageHeader from "@/modules/CRM/components/CrmPageHeader";
import CrmTimelineItem from "@/modules/CRM/components/CrmTimelineItem";
import crmService from "@/modules/CRM/services/crmService";
import { SistemaMixin, priceOptions } from "@/modules/Application";
import { Money } from "v-money";

const TIMELINE_LIMIT = 20;

export default {
  name: "crm-oportunidade-detalhe",
  components: {
    BuscaClienteContato,
    CrmEmptyState,
    CrmPageHeader,
    CrmTimelineItem,
    Money,
  },
  mixins: [SistemaMixin],
  data() {
    return {
      activeTab: 0,
      priceOptions,
      agendas: [],
      agendaDrawerVisible: false,
      agendaForm: this.emptyAgendaForm(),
      agendaHorarios: null,
      agendaHorariosErro: "",
      agendaReagendamento: null,
      agendaReagendamentoForm: this.emptyAgendaReagendamentoForm(),
      agendaReagendamentoHorarios: null,
      agendaReagendamentoHorariosErro: "",
      agendaReagendamentoSelecionandoSlot: false,
      agendaSolicitacaoOrigem: null,
      atividades: [],
      contatoSelecionado: null,
      contratoResponsaveisForm: this.emptyContratoResponsaveisForm(),
      contratoResponsaveisLoading: false,
      contratoResponsaveisTarefa: null,
      dadosForm: this.emptyDadosForm(),
      empresaSelecionada: null,
      erroOportunidade: "",
      fontes: [],
      funis: [],
      listasLoading: false,
      loading: false,
      loadingAgendaHorarios: false,
      loadingAgendaReagendamentoHorarios: false,
      loadingConsultaCepFechamento: false,
      loadingConsultaCnpjFechamento: false,
      linkSolicitacaoForm: this.emptyLinkSolicitacaoForm(),
      linkSolicitacaoGerado: "",
      linkSolicitacaoLoading: false,
      linkSolicitacaoOrigem: null,
      motivosPerda: [],
      nota: "",
      oportunidade: null,
      stageChanging: false,
      solicitacoesTecnicas: [],
      idEtapaDestino: null,
      idUsuarioTecnicoDestino: null,
      idUsuarioDestino: null,
      concederAcessoFunilDestino: false,
      movimentoCamposForm: {},
      movimentoManterValor: true,
      temperaturaForm: {
        temperatura: null,
      },
      ganhoForm: this.emptyGanhoForm(),
      perdaForm: this.emptyPerdaForm(),
      tiposTarefa: [],
      tarefaEditando: null,
      tarefaForm: this.emptyTarefaForm(),
      tarefaAgendamentoOrigem: null,
      tarefaDrawerVisible: false,
      timeline: [],
      timelineFiltro: "todos",
      timelineNotaRapida: "",
      timelineHasMore: false,
      timelineLoading: false,
      timelineUploading: false,
      usuarios: [],
      vendedoresAtribuicao: [],
      desenvolvedoresAtribuicao: [],
      treinamentoAtribuicao: [],
      treinamentoClienteFinalAtribuicao: [],
      websiteAtribuicao: [],
      timelineFiltroOptions: [
        { value: "todos", text: "Todos", icon: "la la-stream" },
        { value: "alteracoes", text: "Alterações", icon: "la la-exchange" },
        { value: "notas", text: "Notas", icon: "la la-sticky-note" },
        { value: "tarefas", text: "Tarefas", icon: "la la-check-square" },
        { value: "agenda", text: "Agenda", icon: "la la-calendar" },
        { value: "contato", text: "Contato", icon: "la la-user" },
        { value: "whatsapp", text: "WhatsApp", icon: "la la-whatsapp" },
        { value: "anexos", text: "Anexos", icon: "la la-paperclip" },
      ],
      tipoAgendaOptions: [
        { value: "follow_up", text: "Follow-up" },
        { value: "reuniao", text: "Reunião" },
        { value: "visita", text: "Visita" },
        { value: "demonstracao", text: "Demonstração" },
        { value: "apresentacao_tecnica", text: "Apresentação técnica" },
        { value: "treinamento", text: "Treinamento" },
        {
          value: "treinamento_cliente_final",
          text: "Treinamento Cliente Final",
        },
        { value: "outro", text: "Outro" },
      ],
      temperaturaOptions: [
        { value: null, text: "Sem temperatura" },
        { value: "muito_frio", text: "Muito frio" },
        { value: "frio", text: "Frio" },
        { value: "morno", text: "Morno" },
        { value: "quente", text: "Quente" },
        { value: "venda_certa", text: "Venda certa" },
      ],
      beneficioOptions: [
        { value: "website", text: "Website" },
        {
          value: "implementacao_white_label",
          text: "Implementação White Label",
        },
        {
          value: "treinamento_cliente_final",
          text: "Treinamento Cliente Final",
        },
      ],
    };
  },
  computed: {
    idOportunidade() {
      return this.$route && this.$route.params ? this.$route.params.id : null;
    },
    backLabel() {
      if (this.$route.query.origem === "ganhas") {
        return "Visão geral";
      }

      return this.$route.query.origem === "funil" ? "Funil" : "Oportunidades";
    },
    backTo() {
      if (this.$route.query.origem === "ganhas") {
        return { name: "crmDashboard" };
      }

      return this.$route.query.origem === "funil"
        ? { name: "crmFunil" }
        : { name: "crmOportunidades" };
    },
    contatoPrincipal() {
      if (!this.oportunidade) {
        return "Sem cliente ou contato";
      }

      return (
        this.oportunidade.contato ||
        this.oportunidade.pessoa ||
        "Sem cliente ou contato"
      );
    },
    nomeClienteFechamento() {
      if (!this.oportunidade) {
        return "";
      }

      return (
        this.oportunidade.contato ||
        this.oportunidade.pessoa ||
        this.oportunidade.titulo ||
        ""
      );
    },
    documentoClienteFechamento() {
      if (!this.oportunidade) {
        return "";
      }

      return (
        this.oportunidade.contato_documento ||
        this.oportunidade.pessoa_cnpj_cpf ||
        this.oportunidade.pessoa_cpf ||
        ""
      );
    },
    contatoTelefone() {
      return this.oportunidade
        ? this.oportunidade.contato_telefone ||
            this.oportunidade.telefone_contato ||
            this.oportunidade.pessoa_telefone ||
            ""
        : "";
    },
    camposComerciaisDetalhe() {
      if (
        !this.oportunidade ||
        !Array.isArray(this.oportunidade.campos_comerciais)
      ) {
        return [];
      }

      if (this.ocultarValoresFinanceirosDetalhe) {
        return this.oportunidade.campos_comerciais.filter(
          (campo) =>
            !["valor_proposta", "valor_negociacao", "valor_final"].includes(
              campo.chave
            )
        );
      }

      return this.oportunidade.campos_comerciais;
    },
    ocultarValoresFinanceirosDetalhe() {
      return ["treinamento", "website"].includes(
        this.oportunidade ? this.oportunidade.tipo_fluxo : null
      );
    },
    valorPropostaDetalhe() {
      return this.valorCampoComercial(this.oportunidade, "valor_proposta");
    },
    valorNegociacaoDetalhe() {
      return this.valorCampoComercial(this.oportunidade, "valor_negociacao");
    },
    valorFinalDetalhe() {
      return this.valorCampoComercial(this.oportunidade, "valor_final");
    },
    valorPrincipalDetalhe() {
      return this.valorPrincipalOportunidade(this.oportunidade);
    },
    cidadeFechamentoLabel() {
      return [this.ganhoForm.cidade, this.ganhoForm.uf]
        .filter(Boolean)
        .join(" / ");
    },
    contatoEmail() {
      return this.oportunidade
        ? this.oportunidade.contato_email ||
            this.oportunidade.pessoa_email ||
            ""
        : "";
    },
    isContrato() {
      return this.oportunidade && this.oportunidade.tipo_fluxo === "contratos";
    },
    whatsappUrl() {
      const telefone = this.normalizarTelefoneWhatsapp(this.contatoTelefone);

      return telefone ? `https://web.whatsapp.com/send?phone=${telefone}` : "";
    },
    empresaLabel() {
      if (!this.oportunidade) {
        return "";
      }

      return (
        this.oportunidade.pessoa || this.oportunidade.pessoa_nome_fantasia || ""
      );
    },
    empresaDocumento() {
      if (!this.oportunidade) {
        return "";
      }

      return this.oportunidade.pessoa_cnpj_cpf || this.oportunidade.pessoa_cpf;
    },
    etapasFunilAtual() {
      if (!this.oportunidade) {
        return [];
      }

      const funil = this.funis.find(
        (item) => item.id_crm_funil === this.oportunidade.id_crm_funil
      );

      if (funil && Array.isArray(funil.etapas) && funil.etapas.length) {
        return funil.etapas;
      }

      return this.oportunidade.etapa
        ? [
            {
              id_crm_etapa: this.oportunidade.id_crm_etapa,
              nome: this.oportunidade.etapa,
            },
          ]
        : [];
    },
    etapaAtualIndex() {
      return this.etapasFunilAtual.findIndex(
        (etapa) => etapa.id_crm_etapa === this.oportunidade.id_crm_etapa
      );
    },
    etapaAtualConfig() {
      return this.etapasFunilAtual.find(
        (etapa) => etapa.id_crm_etapa === this.oportunidade.id_crm_etapa
      );
    },
    automacoesEtapa() {
      const etapa = this.etapaAtualConfig || {};
      const regras = [];

      if (etapa.sugerir_tarefa) {
        regras.push(
          etapa.tarefa_sugerida_titulo || "Sugerir tarefa ao entrar na etapa"
        );
      }

      if (etapa.destacar_sem_tarefa) {
        regras.push("Destacar oportunidade sem tarefa");
      }

      if (etapa.alertar_oportunidade_parada) {
        regras.push(
          `Alertar parada há ${etapa.alerta_parada_dias || 7} dia(s)`
        );
      }

      if (etapa.exigir_motivo_perda) {
        regras.push("Exigir motivo de perda");
      }

      return regras;
    },
    atividadesPendentes() {
      return this.atividades
        .filter((atividade) => atividade.status !== "concluida")
        .slice()
        .sort((a, b) => {
          const dataA = a.vencimento_em
            ? new Date(a.vencimento_em)
            : new Date(0);
          const dataB = b.vencimento_em
            ? new Date(b.vencimento_em)
            : new Date(0);
          return dataA - dataB;
        });
    },
    proximasTarefas() {
      return this.atividadesPendentes.slice(0, 3);
    },
    solicitacoesTecnicasPendentes() {
      return this.solicitacoesTecnicas.filter(
        (solicitacao) => !this.solicitacaoTecnicaFinalizada(solicitacao)
      );
    },
    proximasAcoesPendentesCount() {
      return (
        this.proximasTarefas.length + this.solicitacoesTecnicasPendentes.length
      );
    },
    notasTimeline() {
      return this.timeline.filter((item) =>
        ["nota", "nota_adicionada"].includes(item.tipo_evento)
      );
    },
    timelineAgrupada() {
      return this.agruparTimelinePorDia(this.timeline);
    },
    timelineCountLabel() {
      const total = this.timeline.length;
      const filtro = this.timelineFiltroOptions.find(
        (item) => item.value === this.timelineFiltro
      );
      const label = filtro ? filtro.text.toLowerCase() : "eventos";

      return `${total} ${total === 1 ? "evento" : "eventos"} · ${label}`;
    },
    funilOptions() {
      return this.funis.map((funil) => ({
        value: funil.id_crm_funil,
        text: funil.nome,
      }));
    },
    fonteOptions() {
      return [{ value: null, text: "Sem fonte" }].concat(
        this.fontes.map((fonte) => ({
          value: fonte.id_crm_fonte,
          text: fonte.nome,
        }))
      );
    },
    usuarioOptions() {
      return [{ value: null, text: "Responsável padrão" }].concat(
        this.usuarioOptionsSemTodos
      );
    },
    usuarioOptionsSemTodos() {
      return this.usuarios.map((usuario) => ({
        value: usuario.id_usuario,
        text: usuario.nome || usuario.usuario,
      }));
    },
    agendaResponsavelOptions() {
      return this.isTreinamentoClienteFinal(this.oportunidade)
        ? this.treinamentoResponsavelOptions
        : this.usuarioOptions;
    },
    agendaDrawerTitle() {
      return this.isTreinamentoClienteFinal(this.oportunidade)
        ? "Agendar treinamento"
        : "Criar agendamento CRM";
    },
    tarefaDrawerTitle() {
      return this.tarefaEditando ? "Editar tarefa" : "Criar tarefa";
    },
    agendaResponsavelLabel() {
      return this.isTreinamentoClienteFinal(this.oportunidade)
        ? "Responsável pelo treinamento"
        : "Responsável";
    },
    agendaHorariosContextoLabel() {
      const responsavel =
        this.optionText(
          this.agendaResponsavelOptions,
          this.agendaForm.id_usuario
        ) || "responsável não selecionado";
      const data = this.dateFromDateTimeLocal(this.agendaForm.data_inicio);
      const dataLabel = data
        ? new Date(`${data}T00:00:00`).toLocaleDateString("pt-BR")
        : "data não informada";

      return `${responsavel} em ${dataLabel}`;
    },
    agendaReagendamentoSlots() {
      return this.agendaReagendamentoHorarios
        ? this.agendaReagendamentoHorarios.slots || []
        : [];
    },
    agendaReagendamentoHorariosContextoLabel() {
      const responsavel =
        this.optionText(
          this.usuarioOptionsSemTodos,
          this.agendaReagendamentoResponsavelId()
        ) || "responsável não selecionado";
      const data = this.dateFromDateTimeLocal(
        this.agendaReagendamentoForm.data_inicio
      );
      const dataLabel = data
        ? new Date(`${data}T00:00:00`).toLocaleDateString("pt-BR")
        : "data não informada";

      return `${responsavel} em ${dataLabel}`;
    },
    vendedorResponsavelOptions() {
      const vendedores = this.vendedoresAtribuicao.length
        ? this.vendedoresAtribuicao
        : this.usuarios;

      return vendedores.map((usuario) => ({
        value: usuario.id_usuario,
        text: usuario.nome || usuario.usuario,
      }));
    },
    desenvolvedorResponsavelOptions() {
      const desenvolvedores = this.desenvolvedoresAtribuicao.length
        ? this.desenvolvedoresAtribuicao
        : this.usuarios;

      return desenvolvedores.map((usuario) => ({
        value: usuario.id_usuario,
        text: usuario.nome || usuario.usuario,
      }));
    },
    treinamentoResponsavelOptions() {
      const usuarios = this.treinamentoAtribuicao.length
        ? this.treinamentoAtribuicao
        : this.usuarios;

      return usuarios.map((usuario) => ({
        value: usuario.id_usuario,
        text: usuario.nome || usuario.usuario,
      }));
    },
    treinamentoClienteFinalResponsavelOptions() {
      const usuarios = this.treinamentoClienteFinalAtribuicao.length
        ? this.treinamentoClienteFinalAtribuicao
        : this.usuarios;

      return usuarios.map((usuario) => ({
        value: usuario.id_usuario,
        text: usuario.nome || usuario.usuario,
      }));
    },
    websiteResponsavelOptions() {
      const usuarios = this.websiteAtribuicao.length
        ? this.websiteAtribuicao
        : this.usuarios;

      return usuarios.map((usuario) => ({
        value: usuario.id_usuario,
        text: usuario.nome || usuario.usuario,
      }));
    },
    contratoResponsavelWhiteLabelLabel() {
      return (
        this.optionText(
          this.desenvolvedorResponsavelOptions,
          this.contratoResponsaveisForm.id_usuario_white_label
        ) || "Selecione"
      );
    },
    contratoTreinamentoSelecionadoLabel() {
      return (
        this.optionText(
          this.treinamentoResponsavelOptions,
          this.contratoResponsaveisForm.id_usuario_treinamento
        ) || "Selecione"
      );
    },
    contratoTreinamentoClienteFinalSelecionadoLabel() {
      return (
        this.optionText(
          this.treinamentoClienteFinalResponsavelOptions,
          this.contratoResponsaveisForm.id_usuario_treinamento_cliente_final
        ) || "Selecione"
      );
    },
    contratoWebsiteSelecionadoLabel() {
      return (
        this.optionText(
          this.websiteResponsavelOptions,
          this.contratoResponsaveisForm.id_usuario_website
        ) || "Selecione"
      );
    },
    contratoExigeTreinamento() {
      return this.contratoTemBeneficioTreinamento();
    },
    contratoExigeTreinamentoClienteFinal() {
      return this.contratoTemBeneficioTreinamentoClienteFinal();
    },
    contratoExigeImplementacaoWhiteLabel() {
      if (
        this.oportunidade &&
        this.oportunidade.exige_implementacao_white_label_pos_contrato !==
          undefined
      ) {
        return this.booleanFlag(
          this.oportunidade.exige_implementacao_white_label_pos_contrato
        );
      }

      return this.beneficiosEstruturadosOportunidade().includes(
        "implementacao_white_label"
      );
    },
    contratoExigeWebsite() {
      return this.contratoTemBeneficioWebsite();
    },
    etapaDestinoSelecionada() {
      return this.findEtapaById(this.idEtapaDestino);
    },
    camposObrigatoriosMovimento() {
      return this.camposObrigatoriosEtapa(this.etapaDestinoSelecionada);
    },
    movimentoExigeValorNegociacao() {
      return this.camposObrigatoriosMovimento.some(
        (regra) => this.campoObrigatorioChave(regra) === "valor_negociacao"
      );
    },
    movimentoExigeTecnico() {
      return (
        !this.oportunidadeTemResponsavelTecnico(this.oportunidade) &&
        this.isEtapaApresentacaoTecnica(this.etapaDestinoSelecionada)
      );
    },
    movimentoExigeAtribuicao() {
      return this.movimentoExigeAtribuicaoParaDestino(
        this.etapaDestinoSelecionada
      );
    },
    funilAtualUsuariosAcesso() {
      if (!this.oportunidade) {
        return [];
      }

      const funil = this.funis.find(
        (item) => item.id_crm_funil === this.oportunidade.id_crm_funil
      );
      const acessos =
        funil && funil.usuarios_acesso ? funil.usuarios_acesso : [];

      return acessos
        .filter((acesso) => acesso.ativo !== false)
        .map((acesso) => Number(acesso.id_usuario));
    },
    usuarioDestinoSemAcesso() {
      if (!this.movimentoExigeAtribuicao || !this.idUsuarioDestino) {
        return false;
      }

      if (this.usuarioTemAcessoPorPapelAoFunilAtual(this.idUsuarioDestino)) {
        return false;
      }

      const ids = this.funilAtualUsuariosAcesso;
      return ids.length > 0 && !ids.includes(Number(this.idUsuarioDestino));
    },
    motivoPerdaOptions() {
      return [{ value: null, text: "Selecione" }].concat(
        this.motivosPerda.map((motivo) => ({
          value: motivo.id_crm_motivo_perda,
          text: motivo.nome,
        }))
      );
    },
    agendaSlots() {
      return this.agendaHorarios ? this.agendaHorarios.slots || [] : [];
    },
    tipoTarefaOptions() {
      const ativos = this.tiposTarefa.filter((tipo) => tipo.ativo !== false);
      const tipos = ativos.length
        ? ativos
        : [
            { nome: "Tarefa", chave: "tarefa" },
            { nome: "Ligação", chave: "ligacao" },
            { nome: "Reunião", chave: "reuniao" },
            { nome: "Nota", chave: "nota" },
            { nome: "Follow-up", chave: "follow_up" },
          ];

      return tipos.map((tipo) => ({
        value: tipo.chave,
        text: tipo.nome,
      }));
    },
    agendaClienteLabel() {
      return this.oportunidade
        ? this.oportunidade.pessoa ||
            this.oportunidade.contato ||
            "Sem cliente/contato informado"
        : "-";
    },
    oportunidadeSubtitle() {
      if (!this.oportunidade) {
        return "";
      }

      return [
        this.oportunidade.contato || this.oportunidade.pessoa,
        this.oportunidade.funil?.nome || "Funil não informado",
        this.oportunidade.etapa,
      ]
        .filter(Boolean)
        .join(" · ");
    },
  },
  mounted() {
    this.loadBase();
  },
  watch: {
    idOportunidade(newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        this.loadBase();
      }
    },
    "agendaForm.id_usuario": "resetAgendaHorarios",
    "agendaForm.data_inicio": "resetAgendaHorarios",
    "agendaForm.duracao_minutos": "resetAgendaHorarios",
    "agendaReagendamentoForm.data_inicio": "resetAgendaReagendamentoHorarios",
    "agendaReagendamentoForm.duracao_minutos":
      "resetAgendaReagendamentoHorarios",
  },
  methods: {
    emptyTarefaForm() {
      return {
        titulo: "",
        tipo: "tarefa",
        id_usuario: null,
        vencimento_em: this.toDateTimeLocal(new Date()),
        descricao: "",
        concluir_ao_criar: false,
      };
    },
    emptyAgendaForm() {
      return {
        id_crm_atividade: null,
        titulo: "",
        tipo: "follow_up",
        id_usuario: null,
        data_inicio: this.toDateTimeLocal(new Date()),
        duracao_minutos: 30,
        descricao: "",
      };
    },
    emptyAgendaReagendamentoForm() {
      return {
        data_inicio: "",
        duracao_minutos: 30,
        motivo_reagendamento: "",
      };
    },
    emptyLinkSolicitacaoForm() {
      const periodo = this.periodoLinkSolicitacaoTecnica();

      return {
        data_inicio: periodo.data_inicio,
        data_fim: periodo.data_fim,
        duracao_minutos: 30,
        observacoes: "",
      };
    },
    emptyContratoResponsaveisForm() {
      return {
        id_usuario_white_label: null,
        id_usuario_treinamento: null,
        id_usuario_treinamento_cliente_final: null,
        id_usuario_website: null,
        exige_treinamento: false,
        exige_treinamento_cliente_final: false,
        exige_website: false,
      };
    },
    emptyPerdaForm() {
      return {
        id_crm_motivo_perda: null,
        motivo_perda_observacao: "",
      };
    },
    emptyGanhoForm() {
      return {
        titulo: "",
        cliente: "",
        nome_correto: "",
        cnpj: "",
        email_cliente: "",
        telefone_cliente: "",
        endereco_cliente: "",
        cep: "",
        logradouro: "",
        numero: "",
        bairro: "",
        complemento: "",
        id_cidade: null,
        cidade: "",
        uf: "",
        valor_final: 0,
        beneficios: "",
        beneficios_livres: "",
        beneficios_estruturados: [],
        cliente_final: false,
      };
    },
    emptyDadosForm() {
      return {
        titulo: "",
        id_crm_funil: null,
        id_crm_etapa: null,
        id_usuario: null,
        id_crm_fonte: null,
        campanha: "",
        temperatura: null,
        valor_estimado: 0,
        previsao_fechamento: null,
        proxima_atividade_em: null,
        campos_comerciais: {},
      };
    },
    async loadBase() {
      this.loading = true;
      this.erroOportunidade = "";

      try {
        await this.loadOportunidade();
      } catch (error) {
        this.erroOportunidade = this.erroMensagem(
          error,
          "Não foi possível abrir este card."
        );
        this.$toast.error(this.erroOportunidade);
        this.loading = false;
        return;
      }

      this.loading = false;

      const resultados = await Promise.allSettled([
        this.loadTimeline(true),
        this.loadAuxiliares(),
        this.loadRelacionados(),
      ]);
      const falha = resultados.find(
        (resultado) => resultado.status === "rejected"
      );

      if (falha) {
        this.$toast.error(
          this.erroMensagem(
            falha.reason,
            "Algumas informações do card não puderam ser carregadas."
          )
        );
      }
    },
    async loadAuxiliares() {
      const [
        motivos,
        usuarios,
        tiposTarefa,
        funis,
        fontes,
        temperaturas,
        vendedoresAtribuicao,
        desenvolvedoresAtribuicao,
        treinamentoAtribuicao,
        treinamentoClienteFinalAtribuicao,
        websiteAtribuicao,
      ] = (
        await Promise.allSettled([
          crmService.motivosPerda(),
          crmService.usuarios({
            page: 1,
            per_page: 100,
            sort: [{ field: "nome", type: "asc" }],
          }),
          crmService.tiposTarefaConfiguracao(),
          crmService.funis(),
          crmService.fontes(),
          crmService.temperaturasConfiguracao(),
          crmService.usuariosAtribuicoesConfiguracao({ papel: "vendedor" }),
          crmService.usuariosAtribuicoesConfiguracao({
            papel: "desenvolvedor",
          }),
          crmService.usuariosAtribuicoesConfiguracao({ papel: "treinamento" }),
          crmService.usuariosAtribuicoesConfiguracao({
            papel: "treinamento_cliente_final",
          }),
          crmService.usuariosAtribuicoesConfiguracao({ papel: "website" }),
        ])
      ).map((resultado) =>
        resultado.status === "fulfilled" ? resultado.value : null
      );
      this.motivosPerda = this.normalizeCollection(
        motivos ? motivos.data : null
      );
      this.usuarios = this.normalizeCollection(usuarios ? usuarios.data : null);
      this.tiposTarefa = this.normalizeCollection(
        tiposTarefa ? tiposTarefa.data : null
      );
      this.funis = this.normalizeCollection(funis ? funis.data : null);
      this.fontes = this.normalizeCollection(fontes ? fontes.data : null);
      this.temperaturaOptions = this.temperaturaOptionsFromList(
        this.normalizeCollection(temperaturas ? temperaturas.data : null)
      );
      this.vendedoresAtribuicao =
        this.vendedoresFromAtribuicoes(vendedoresAtribuicao);
      this.desenvolvedoresAtribuicao = this.desenvolvedoresFromAtribuicoes(
        desenvolvedoresAtribuicao
      );
      this.treinamentoAtribuicao = this.usuariosPorPapelFromAtribuicoes(
        treinamentoAtribuicao,
        "treinamento"
      );
      this.treinamentoClienteFinalAtribuicao =
        this.usuariosPorPapelFromAtribuicoes(
          treinamentoClienteFinalAtribuicao,
          "treinamento_cliente_final"
        );
      this.websiteAtribuicao = this.usuariosPorPapelFromAtribuicoes(
        websiteAtribuicao,
        "website"
      );
    },
    async loadOportunidade() {
      const { data } = await crmService.detalheOportunidade({
        id_crm_oportunidade: this.idOportunidade,
        origem: this.$route.query.origem || null,
      });
      const oportunidade =
        data && data.status === true && data.data ? data.data : data;

      if (data && data.status === false) {
        throw new Error(
          data.msg || data.message || "Oportunidade não encontrada."
        );
      }

      if (!oportunidade || !oportunidade.id_crm_oportunidade) {
        throw new Error("Oportunidade não encontrada.");
      }

      this.oportunidade = oportunidade;
    },
    async loadRelacionados() {
      this.listasLoading = true;

      try {
        const resultados = await Promise.allSettled([
          this.loadAtividades(),
          this.loadAgendas(),
          this.loadSolicitacoesTecnicas(),
        ]);
        const falha = resultados.find(
          (resultado) => resultado.status === "rejected"
        );

        if (falha) {
          this.$toast.error(
            this.erroMensagem(
              falha.reason,
              "Algumas listas do card não puderam ser carregadas."
            )
          );
        }
      } finally {
        this.listasLoading = false;
      }
    },
    async loadAtividades() {
      const { data } = await crmService.atividades({
        page: 1,
        per_page: 100,
        consolidar_fluxo: true,
        columnFilters: {
          id_crm_oportunidade: this.idOportunidade,
        },
        sort: [{ field: "vencimento_em", type: "asc" }],
      });
      this.atividades = this.normalizeCollection(data);
    },
    async loadAgendas() {
      const periodo = this.periodoAgendaDetalhe();
      const { data } = await crmService.agenda({
        ...periodo,
        id_crm_oportunidade: this.idOportunidade,
        consolidar_fluxo: true,
        page: 1,
        per_page: 100,
        sort: [{ field: "data_inicio", type: "asc" }],
      });
      this.agendas = this.normalizeCollection(data);
    },
    async loadSolicitacoesTecnicas() {
      const { data } = await crmService.solicitacoesTecnicasAgenda({
        id_crm_oportunidade: this.idOportunidade,
        page: 1,
        per_page: 20,
        sort: [{ field: "created_at", type: "desc" }],
      });
      this.solicitacoesTecnicas = this.normalizeCollection(data);
    },
    async loadTimeline(reset) {
      this.timelineLoading = reset;
      const offset = reset ? 0 : this.timeline.length;

      try {
        const { data } = await crmService.timeline({
          id_crm_oportunidade: this.idOportunidade,
          categoria: this.timelineFiltro,
          limit: TIMELINE_LIMIT,
          offset,
        });
        const itens = this.normalizeCollection(data);
        this.timeline = reset ? itens : this.timeline.concat(itens);
        this.timelineHasMore = itens.length === TIMELINE_LIMIT;
      } finally {
        this.timelineLoading = false;
      }
    },
    alterarFiltroTimeline(filtro) {
      if (this.timelineFiltro === filtro) {
        return;
      }

      this.timelineFiltro = filtro;
      this.loadTimeline(true);
    },
    async salvarNotaRapida() {
      const descricao = (this.timelineNotaRapida || "").trim();

      if (!descricao) {
        this.$toast.error("Informe a nota.");
        return;
      }

      await crmService.adicionarNota({
        id_crm_oportunidade: this.idOportunidade,
        id_crm_contato: this.oportunidade.id_crm_contato,
        descricao,
      });
      this.timelineNotaRapida = "";
      this.timelineFiltro = "notas";
      this.$toast.success("Nota adicionada ao histórico.");
      await Promise.all([
        this.loadTimeline(true),
        this.loadOportunidade(),
        this.loadRelacionados(),
      ]);
    },
    abrirUploadAnexoTimeline() {
      if (this.timelineUploading) {
        return;
      }

      this.$refs.timelineAnexoInput?.click();
    },
    async salvarAnexoTimeline(event) {
      const file = event.target.files && event.target.files[0];

      if (!file) {
        return;
      }

      const formData = new FormData();
      formData.append("id_crm_oportunidade", this.idOportunidade);
      if (this.oportunidade.id_crm_contato) {
        formData.append("id_crm_contato", this.oportunidade.id_crm_contato);
      }
      formData.append("arquivo", file);

      this.timelineUploading = true;

      try {
        await crmService.adicionarAnexo(formData);
        this.timelineFiltro = "anexos";
        this.$toast.success("Anexo adicionado ao histórico.");
        await this.loadTimeline(true);
      } finally {
        this.timelineUploading = false;
        event.target.value = "";
      }
    },
    async adicionarNota() {
      if (!this.nota) {
        this.$toast.error("Informe a nota.");
        return;
      }

      await crmService.adicionarNota({
        id_crm_oportunidade: this.idOportunidade,
        id_crm_contato: this.oportunidade.id_crm_contato,
        descricao: this.nota,
      });
      this.nota = "";
      this.$toast.success("Nota adicionada com sucesso.");
      this.afterAction();
    },
    abrirModalDados() {
      this.dadosForm = {
        titulo: this.oportunidade.titulo || "",
        id_crm_funil: this.oportunidade.id_crm_funil,
        id_crm_etapa: this.oportunidade.id_crm_etapa,
        id_usuario: this.oportunidade.id_usuario,
        id_crm_fonte: this.oportunidade.id_crm_fonte || null,
        campanha: this.oportunidade.campanha || "",
        temperatura: this.oportunidade.temperatura || null,
        valor_estimado: this.oportunidade.valor_estimado || 0,
        previsao_fechamento: this.toDateInput(
          this.oportunidade.previsao_fechamento
        ),
        proxima_atividade_em: this.toDateTimeLocal(
          this.oportunidade.proxima_atividade_em
        ),
        campos_comerciais: this.camposComerciaisFormValues(),
      };
      this.$bvModal.show("crm-detalhe-dados-modal");
    },
    onDadosFunilChange() {
      const etapas = this.etapaOptions(this.dadosForm.id_crm_funil);
      this.dadosForm.id_crm_etapa = etapas.length ? etapas[0].value : null;
    },
    async salvarDados() {
      const titulo = (this.dadosForm.titulo || "").trim();

      if (!titulo) {
        this.$toast.error("Informe o título da oportunidade.");
        return;
      }

      if (!this.dadosForm.id_crm_funil || !this.dadosForm.id_crm_etapa) {
        this.$toast.error("Selecione o funil e a etapa.");
        return;
      }

      await crmService.atualizarOportunidade({
        id_crm_oportunidade: this.idOportunidade,
        ...this.dadosForm,
        titulo,
        campanha: this.dadosForm.campanha || null,
        valor_estimado: Number(this.dadosForm.valor_estimado || 0),
        previsao_fechamento: this.dadosForm.previsao_fechamento || null,
        proxima_atividade_em: this.fromDateTimeLocal(
          this.dadosForm.proxima_atividade_em
        ),
        campos_comerciais: this.camposComerciaisPayload(),
      });
      this.$toast.success("Dados comerciais atualizados.");
      this.$bvModal.hide("crm-detalhe-dados-modal");
      this.afterAction();
    },
    abrirModalContato() {
      this.contatoSelecionado = null;
      this.$bvModal.show("crm-detalhe-contato-modal");
    },
    async criarContatoRapidoOportunidade(payload) {
      const contatoPayload =
        typeof payload === "string"
          ? { nome: payload, origem_criacao_rapida: true }
          : { ...payload, origem_criacao_rapida: true };
      const { data } = await crmService.criarContato(contatoPayload);
      const contato = data.contato || data;
      this.contatoSelecionado = {
        tipo: "contato",
        label: contato.nome,
        id_crm_contato: contato.id_crm_contato,
        id_pessoa: contato.id_pessoa || null,
        id_crm_oportunidade: null,
        raw: contato,
      };
      this.$toast.success("Contato criado e selecionado.");
    },
    async salvarContatoOportunidade() {
      if (!this.contatoSelecionado) {
        this.$toast.error("Selecione ou crie um contato.");
        return;
      }

      await crmService.atualizarOportunidade({
        id_crm_oportunidade: this.idOportunidade,
        id_crm_contato: this.contatoSelecionado.id_crm_contato,
        id_pessoa:
          this.contatoSelecionado.id_pessoa || this.oportunidade.id_pessoa,
      });
      this.$toast.success("Contato da oportunidade atualizado.");
      this.$bvModal.hide("crm-detalhe-contato-modal");
      this.afterAction();
    },
    abrirModalEmpresa() {
      this.empresaSelecionada = null;
      this.$bvModal.show("crm-detalhe-empresa-modal");
    },
    async salvarEmpresaOportunidade() {
      if (!this.empresaSelecionada || !this.empresaSelecionada.id_pessoa) {
        this.$toast.error("Selecione uma Pessoa existente.");
        return;
      }

      if (this.oportunidade.id_crm_contato) {
        await crmService.vincularPessoaContato({
          id_crm_contato: this.oportunidade.id_crm_contato,
          id_pessoa: this.empresaSelecionada.id_pessoa,
        });
      }

      await crmService.atualizarOportunidade({
        id_crm_oportunidade: this.idOportunidade,
        id_pessoa: this.empresaSelecionada.id_pessoa,
      });
      this.$toast.success("Empresa/pessoa associada à oportunidade.");
      this.$bvModal.hide("crm-detalhe-empresa-modal");
      this.afterAction();
    },
    async copiarTelefoneContato() {
      if (!this.contatoTelefone) {
        return;
      }

      try {
        if (this.$copyText) {
          await this.$copyText(this.contatoTelefone);
        } else if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(this.contatoTelefone);
        } else {
          this.copiarTelefoneFallback(this.contatoTelefone);
        }

        this.$toast.success("Telefone copiado.");
      } catch (error) {
        this.copiarTelefoneFallback(this.contatoTelefone);
        this.$toast.success("Telefone copiado.");
      }
    },
    copiarTelefoneFallback(telefone) {
      const input = document.createElement("textarea");
      input.value = telefone;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
    },
    async copiarTexto(texto) {
      if (!texto) {
        return;
      }

      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(texto);
        } else if (this.$copyText) {
          await this.$copyText(texto);
        } else {
          this.copiarTelefoneFallback(texto);
        }

        this.$toast.success("Link copiado.");
      } catch (error) {
        try {
          this.copiarTelefoneFallback(texto);
          this.$toast.success("Link copiado.");
        } catch (fallbackError) {
          this.$toast.error("Não foi possível copiar o link.");
        }
      }
    },
    abrirWhatsappContato() {
      if (!this.whatsappUrl) {
        return;
      }

      window.open(this.whatsappUrl, "_blank", "noopener");
    },
    abrirDadosNegociacao() {
      this.$bvModal.show("crm-detalhe-dados-negociacao-modal");
    },
    enviarContratoWhatsapp() {
      if (!this.whatsappUrl) {
        this.$toast.error("Telefone não informado para enviar o contrato.");
        return;
      }

      const telefone = this.normalizarTelefoneWhatsapp(this.contatoTelefone);
      const mensagem = `Olá ${this.contatoPrincipal}, segue o contrato referente à negociação ${this.oportunidade.titulo}.`;
      window.open(
        `https://web.whatsapp.com/send?phone=${telefone}&text=${encodeURIComponent(
          mensagem
        )}`,
        "_blank",
        "noopener"
      );
    },
    enviarContratoEmail() {
      if (!this.contatoEmail) {
        this.$toast.error("E-mail não informado para enviar o contrato.");
        return;
      }

      const assunto = `Contrato - ${this.contatoPrincipal}`;
      const corpo = `Olá,\n\nSegue o contrato referente à negociação ${
        this.oportunidade.titulo
      }.\n\nValor negociado: ${this.formatMoney(
        this.valorPrincipalDetalhe
      )}.\n`;
      window.location.href = `mailto:${
        this.contatoEmail
      }?subject=${encodeURIComponent(assunto)}&body=${encodeURIComponent(
        corpo
      )}`;
    },
    isTarefaContrato(tarefa) {
      return tarefa && tarefa.tipo === "contrato_assinado";
    },
    contratoTemBeneficioWebsite() {
      if (
        this.oportunidade &&
        this.oportunidade.exige_website_pos_contrato !== undefined
      ) {
        return this.booleanFlag(this.oportunidade.exige_website_pos_contrato);
      }

      return this.beneficiosEstruturadosOportunidade().includes("website");
    },
    contratoTemBeneficioTreinamento() {
      if (
        this.oportunidade &&
        this.oportunidade.exige_treinamento_pos_contrato !== undefined
      ) {
        return this.booleanFlag(
          this.oportunidade.exige_treinamento_pos_contrato
        );
      }

      return false;
    },
    contratoTemBeneficioTreinamentoClienteFinal() {
      if (
        this.oportunidade &&
        this.oportunidade.exige_treinamento_cliente_final_pos_contrato !==
          undefined
      ) {
        return this.booleanFlag(
          this.oportunidade.exige_treinamento_cliente_final_pos_contrato
        );
      }

      return this.beneficiosEstruturadosOportunidade().includes(
        "treinamento_cliente_final"
      );
    },
    oportunidadeVendaClienteFinal() {
      return (
        this.oportunidade &&
        (this.oportunidade.tipo_fluxo === "vendas_cliente_final" ||
          this.oportunidade.funil_chave_preset === "vendas_cliente_final")
      );
    },
    async abrirModalResponsaveisContrato(tarefa) {
      const exigeTreinamento = this.contratoExigeTreinamento;
      const exigeTreinamentoClienteFinal =
        this.contratoExigeTreinamentoClienteFinal;
      const exigeImplementacao = this.contratoExigeImplementacaoWhiteLabel;
      const exigeWebsite = this.contratoExigeWebsite;

      await this.ensureContratoResponsaveisOptions({
        exige_treinamento: exigeTreinamento,
        exige_treinamento_cliente_final: exigeTreinamentoClienteFinal,
        exige_implementacao_white_label: exigeImplementacao,
        exige_website: exigeWebsite,
      });

      this.contratoResponsaveisTarefa = tarefa;
      this.contratoResponsaveisForm = {
        ...this.emptyContratoResponsaveisForm(),
        id_usuario_white_label: exigeImplementacao
          ? this.idResponsavelWhiteLabelPadrao()
          : null,
        id_usuario_treinamento_cliente_final: exigeTreinamentoClienteFinal
          ? this.idResponsavelTreinamentoClienteFinalPadrao()
          : null,
        exige_treinamento: exigeTreinamento,
        exige_treinamento_cliente_final: exigeTreinamentoClienteFinal,
        exige_implementacao_white_label: exigeImplementacao,
        exige_website: exigeWebsite,
      };
      this.$bvModal.show("crm-detalhe-responsaveis-contrato-modal");
    },
    async ensureContratoResponsaveisOptions(form = {}) {
      const precisaImplementacao =
        form.exige_implementacao_white_label !== false;
      const precisaTreinamento = !!form.exige_treinamento;
      const precisaTreinamentoClienteFinal =
        !!form.exige_treinamento_cliente_final;
      const precisaWebsite = !!form.exige_website;
      const temOpcoes =
        (!precisaImplementacao ||
          this.desenvolvedorResponsavelOptions.length > 0) &&
        (!precisaTreinamento ||
          this.treinamentoResponsavelOptions.length > 0) &&
        (!precisaTreinamentoClienteFinal ||
          this.treinamentoClienteFinalResponsavelOptions.length > 0) &&
        (!precisaWebsite || this.websiteResponsavelOptions.length > 0);

      if (temOpcoes) {
        return;
      }

      await this.loadAuxiliares();
    },
    idResponsavelTreinamentoClienteFinalPadrao() {
      const primeiro = this.treinamentoClienteFinalResponsavelOptions.find(
        (option) => option.value
      );

      return primeiro ? primeiro.value : null;
    },
    idResponsavelWhiteLabelPadrao() {
      if (!this.oportunidade) {
        return null;
      }

      const tecnico = Number(
        this.oportunidade.id_responsavel_tecnico ||
          this.valorCampoComercial(this.oportunidade, "id_responsavel_tecnico")
      );
      if (
        tecnico &&
        this.optionText(this.desenvolvedorResponsavelOptions, tecnico)
      ) {
        return tecnico;
      }

      const primeiroDesenvolvedor = this.desenvolvedorResponsavelOptions.find(
        (option) => option.value
      );

      return primeiroDesenvolvedor ? Number(primeiroDesenvolvedor.value) : null;
    },
    abrirModalTarefa() {
      this.tarefaEditando = null;
      this.tarefaForm = this.emptyTarefaForm();
      this.tarefaForm.id_usuario = this.oportunidade.id_usuario;
      this.tarefaForm.tipo = this.tipoTarefaOptions.length
        ? this.tipoTarefaOptions[0].value
        : "tarefa";
      this.tarefaDrawerVisible = true;
    },
    abrirEditarTarefa(tarefa) {
      if (tarefa.status !== "aberta") {
        this.$toast.warning("Tarefas concluídas não podem ser editadas.");
        return;
      }

      this.tarefaEditando = tarefa;
      this.tarefaForm = {
        titulo: tarefa.titulo || "",
        tipo: tarefa.tipo || "tarefa",
        id_usuario: tarefa.id_usuario || this.oportunidade.id_usuario,
        vencimento_em: tarefa.vencimento_em
          ? this.toDateTimeLocal(tarefa.vencimento_em)
          : this.toDateTimeLocal(new Date()),
        descricao: tarefa.descricao || "",
        concluir_ao_criar: false,
      };
      this.tarefaDrawerVisible = true;
    },
    async salvarTarefa(agendar = false) {
      if (!this.tarefaForm.titulo) {
        this.$toast.error("Informe o título da tarefa.");
        return;
      }

      let atividade = null;

      try {
        const payload = {
          ...this.tarefaForm,
          vencimento_em: this.fromDateTimeLocal(this.tarefaForm.vencimento_em),
        };
        const response = this.tarefaEditando
          ? await crmService.atualizarAtividade({
              ...payload,
              id_crm_atividade: this.tarefaEditando.id_crm_atividade,
            })
          : await crmService.criarAtividade({
              ...payload,
              id_crm_oportunidade: this.idOportunidade,
              id_crm_contato: this.oportunidade.id_crm_contato,
            });
        atividade = this.responseData(response);
        this.$toast.success(
          this.tarefaEditando
            ? "Tarefa atualizada com sucesso."
            : "Tarefa criada com sucesso."
        );
        this.tarefaDrawerVisible = false;
        this.tarefaEditando = null;
      } catch (error) {
        this.$toast.error(
          this.erroMensagem(error, "Não foi possível salvar a tarefa.")
        );
        return;
      }

      if (agendar) {
        this.abrirModalAgenda(atividade);
      }

      this.afterAction();
    },
    abrirModalAgenda(tarefa = null) {
      const treinamentoClienteFinal = this.isTreinamentoClienteFinal(
        this.oportunidade
      );
      this.agendaForm = this.emptyAgendaForm();
      this.agendaForm.id_usuario = treinamentoClienteFinal
        ? this.idPrimeiroResponsavelTreinamento()
        : this.oportunidade.id_usuario;
      this.agendaForm.titulo = treinamentoClienteFinal
        ? `Treinamento - ${this.oportunidade.titulo}`
        : `Agenda - ${this.oportunidade.titulo}`;
      this.agendaForm.tipo = treinamentoClienteFinal
        ? "treinamento_cliente_final"
        : this.agendaForm.tipo;
      this.agendaForm.descricao = treinamentoClienteFinal
        ? "Agendamento criado a partir do funil Treinamento Cliente Final."
        : this.agendaForm.descricao;
      this.tarefaAgendamentoOrigem = tarefa;
      this.agendaSolicitacaoOrigem = null;

      if (tarefa) {
        this.preencherAgendaPorTarefa(tarefa);
      }

      this.agendaHorarios = null;
      this.agendaHorariosErro = "";
      this.agendaDrawerVisible = true;
    },
    preencherAgendaPorTarefa(tarefa) {
      const treinamentoClienteFinal = this.isTreinamentoClienteFinal(
        this.oportunidade
      );
      const agendarTreinamento = tarefa.tipo === "agendar_treinamento";
      this.agendaForm.id_crm_atividade = tarefa.id_crm_atividade || null;
      this.agendaForm.titulo =
        treinamentoClienteFinal || agendarTreinamento
          ? `Treinamento - ${this.oportunidade.titulo}`
          : `Tarefa - ${tarefa.titulo}`;
      this.agendaForm.id_usuario =
        treinamentoClienteFinal || agendarTreinamento
          ? this.agendaForm.id_usuario ||
            this.idPrimeiroResponsavelTreinamento() ||
            tarefa.id_usuario ||
            this.oportunidade.id_usuario
          : tarefa.id_usuario || this.oportunidade.id_usuario;
      this.agendaForm.tipo = treinamentoClienteFinal
        ? "treinamento_cliente_final"
        : agendarTreinamento
        ? "treinamento"
        : this.agendaForm.tipo;
      this.agendaForm.data_inicio = tarefa.vencimento_em
        ? this.toDateTimeLocal(tarefa.vencimento_em)
        : this.agendaForm.data_inicio;
      this.agendaForm.descricao = [
        `Tarefa: ${tarefa.titulo}`,
        `Tipo: ${this.tipoTarefaLabel(tarefa.tipo)}`,
        tarefa.descricao ? `Descrição: ${tarefa.descricao}` : null,
      ]
        .filter(Boolean)
        .join("\n");
    },
    abrirAgendaSolicitacaoTecnica(solicitacao, buscarHorarios = false) {
      this.agendaForm = this.emptyAgendaForm();
      this.agendaSolicitacaoOrigem = solicitacao;
      this.tarefaAgendamentoOrigem = {
        id_crm_atividade: solicitacao.id_crm_atividade,
        titulo: "Apresentação técnica",
      };
      this.agendaForm.id_crm_atividade = solicitacao.id_crm_atividade || null;
      this.agendaForm.id_usuario =
        solicitacao.id_usuario_tecnico || this.oportunidade.id_usuario;
      this.agendaForm.titulo = `Apresentação técnica - ${this.oportunidade.titulo}`;
      this.agendaForm.tipo = "apresentacao_tecnica";
      this.agendaForm.duracao_minutos = solicitacao.link_duracao_minutos || 30;
      this.agendaForm.descricao = [
        "Solicitação de apresentação técnica do CRM.",
        solicitacao.observacoes
          ? `Observações: ${solicitacao.observacoes}`
          : null,
      ]
        .filter(Boolean)
        .join("\n");
      this.agendaHorarios = null;
      this.agendaHorariosErro = "";
      this.agendaDrawerVisible = true;

      if (buscarHorarios) {
        this.$nextTick(() => this.buscarHorariosAgenda());
      }
    },
    async buscarHorariosAgenda() {
      if (!this.agendaForm.id_usuario) {
        this.$toast.error("Selecione o responsável.");
        return;
      }

      this.loadingAgendaHorarios = true;
      this.agendaHorariosErro = "";

      try {
        const { data } = await crmService.horariosDisponiveisAgenda({
          data: this.dateFromDateTimeLocal(this.agendaForm.data_inicio),
          id_usuario: this.agendaForm.id_usuario,
          id_crm_oportunidade: this.idOportunidade,
          id_crm_atividade: this.agendaForm.id_crm_atividade,
          duracao_minutos: Number(this.agendaForm.duracao_minutos || 30),
        });
        this.agendaHorarios = data;
      } catch (error) {
        this.agendaHorarios = null;
        this.agendaHorariosErro = this.apiError(
          error,
          "Não foi possível buscar os horários."
        );
      } finally {
        this.loadingAgendaHorarios = false;
      }
    },
    resetAgendaHorarios() {
      if (!this.agendaDrawerVisible) {
        return;
      }

      this.agendaHorarios = null;
      this.agendaHorariosErro = "";
    },
    selecionarHorarioAgenda(slot) {
      if (!slot.disponivel) {
        return;
      }

      this.agendaForm.data_inicio = this.toDateTimeLocal(slot.inicio);
    },
    agendaSlotSelecionado(slot) {
      return this.agendaForm.data_inicio === this.toDateTimeLocal(slot.inicio);
    },
    agendaReagendamentoResponsavelId() {
      return (
        this.agendaReagendamento?.id_usuario ||
        this.agendaReagendamento?.agenda_ativa_id_usuario ||
        this.oportunidade?.id_usuario ||
        null
      );
    },
    agendaReagendamentoAtividadeId() {
      return (
        this.agendaReagendamento?.id_crm_atividade ||
        this.agendaReagendamento?.agenda_ativa_id_crm_atividade ||
        null
      );
    },
    async buscarHorariosReagendamentoAgenda() {
      const idUsuario = this.agendaReagendamentoResponsavelId();

      if (!idUsuario) {
        this.$toast.error("Não encontrei o responsável deste agendamento.");
        return;
      }

      this.loadingAgendaReagendamentoHorarios = true;
      this.agendaReagendamentoHorariosErro = "";

      try {
        const { data } = await crmService.horariosDisponiveisAgenda({
          data: this.dateFromDateTimeLocal(
            this.agendaReagendamentoForm.data_inicio
          ),
          id_usuario: idUsuario,
          id_crm_oportunidade: this.idOportunidade,
          id_crm_atividade: this.agendaReagendamentoAtividadeId(),
          id_crm_agenda: this.agendaReagendamento?.id_crm_agenda || null,
          duracao_minutos: Number(
            this.agendaReagendamentoForm.duracao_minutos || 30
          ),
        });
        this.agendaReagendamentoHorarios = data;
      } catch (error) {
        this.agendaReagendamentoHorarios = null;
        this.agendaReagendamentoHorariosErro = this.apiError(
          error,
          "Não foi possível buscar os horários."
        );
      } finally {
        this.loadingAgendaReagendamentoHorarios = false;
      }
    },
    resetAgendaReagendamentoHorarios() {
      if (
        !this.agendaReagendamento ||
        this.agendaReagendamentoSelecionandoSlot
      ) {
        return;
      }

      this.agendaReagendamentoHorarios = null;
      this.agendaReagendamentoHorariosErro = "";
    },
    selecionarHorarioReagendamentoAgenda(slot) {
      if (!slot.disponivel) {
        return;
      }

      this.agendaReagendamentoSelecionandoSlot = true;
      this.agendaReagendamentoForm.data_inicio = this.toDateTimeLocal(
        slot.inicio
      );
      this.$nextTick(() => {
        this.agendaReagendamentoSelecionandoSlot = false;
      });
    },
    agendaReagendamentoSlotSelecionado(slot) {
      return (
        this.agendaReagendamentoForm.data_inicio ===
        this.toDateTimeLocal(slot.inicio)
      );
    },
    async criarAgenda() {
      if (!this.agendaForm.titulo || !this.agendaForm.data_inicio) {
        this.$toast.error("Informe o título e a data do agendamento.");
        return;
      }

      if (this.agendaSolicitacaoOrigem) {
        await crmService.agendarSolicitacaoTecnica({
          id_crm_solicitacao_tecnica:
            this.agendaSolicitacaoOrigem.id_crm_solicitacao_tecnica,
          data_inicio: this.fromDateTimeLocal(this.agendaForm.data_inicio),
          duracao_minutos: Number(this.agendaForm.duracao_minutos || 30),
          observacoes: this.agendaForm.descricao,
        });
        this.$toast.success("Apresentação técnica agendada com sucesso.");
        this.agendaDrawerVisible = false;
        this.tarefaAgendamentoOrigem = null;
        this.agendaSolicitacaoOrigem = null;
        this.afterAction();
        return;
      }

      await crmService.criarAgendamento({
        ...this.agendaForm,
        id_crm_oportunidade: this.idOportunidade,
        id_crm_contato: this.oportunidade.id_crm_contato,
        id_crm_atividade: this.agendaForm.id_crm_atividade,
        observacoes: this.tarefaAgendamentoOrigem
          ? `Agendamento criado a partir da tarefa #${this.tarefaAgendamentoOrigem.id_crm_atividade}: ${this.tarefaAgendamentoOrigem.titulo}`
          : this.agendaForm.descricao,
        data_inicio: this.fromDateTimeLocal(this.agendaForm.data_inicio),
      });
      this.$toast.success(
        this.isTreinamentoClienteFinal(this.oportunidade)
          ? "Treinamento agendado e enviado ao funil Treinamento."
          : this.tarefaAgendamentoOrigem &&
            this.tarefaAgendamentoOrigem.tipo === "agendar_treinamento"
          ? "Treinamento agendado com sucesso."
          : "Agendamento CRM criado com sucesso."
      );
      this.agendaDrawerVisible = false;
      this.tarefaAgendamentoOrigem = null;
      this.agendaSolicitacaoOrigem = null;
      this.afterAction();
    },
    abrirReagendamentoAgenda(agenda) {
      this.agendaReagendamento = agenda;
      this.agendaReagendamentoForm = {
        data_inicio: this.toDateTimeLocal(agenda.data_inicio),
        duracao_minutos: Number(agenda.duracao_minutos || 30),
        motivo_reagendamento: "",
      };
      this.agendaReagendamentoHorarios = null;
      this.agendaReagendamentoHorariosErro = "";
      this.$bvModal.show("crm-detalhe-reagendar-agenda-modal");
      this.$nextTick(() => this.buscarHorariosReagendamentoAgenda());
    },
    abrirReagendamentoTarefa(tarefa) {
      const agenda = this.agendaAtivaDaTarefa(tarefa);

      if (!agenda) {
        this.$toast.warning("Não encontrei o agendamento ativo desta tarefa.");
        return;
      }

      this.abrirReagendamentoAgenda(agenda);
    },
    async confirmarReagendamentoAgenda(event) {
      event.preventDefault();

      const agenda = this.agendaReagendamento;
      const motivo = String(
        this.agendaReagendamentoForm.motivo_reagendamento || ""
      ).trim();
      const duracao = Number(this.agendaReagendamentoForm.duracao_minutos || 0);

      if (!agenda || !this.agendaReagendamentoForm.data_inicio) {
        this.$toast.warning("Informe a nova data do agendamento.");
        return;
      }

      if (!Number.isInteger(duracao) || duracao < 1 || duracao > 1440) {
        this.$toast.warning("Informe uma duração entre 1 minuto e 24 horas.");
        return;
      }

      if (motivo.length < 3) {
        this.$toast.warning("Informe o motivo do reagendamento.");
        return;
      }

      await crmService.reagendarAgendamento({
        id_crm_agenda: agenda.id_crm_agenda,
        data_inicio: this.fromDateTimeLocal(
          this.agendaReagendamentoForm.data_inicio
        ),
        duracao_minutos: duracao,
        motivo_reagendamento: motivo,
      });

      this.$bvModal.hide("crm-detalhe-reagendar-agenda-modal");
      this.$toast.success("Agendamento reagendado.");
      await this.afterAction();
    },
    async cancelarAgenda(agenda) {
      const result = await this.$swal.fire({
        icon: "warning",
        title: "Cancelar agendamento",
        input: "textarea",
        inputLabel: "Motivo do cancelamento",
        inputPlaceholder: "Descreva o motivo",
        inputAttributes: {
          maxlength: 500,
        },
        showCancelButton: true,
        confirmButtonText: "Cancelar agendamento",
        cancelButtonText: "Voltar",
        preConfirm: (motivo) => {
          if (!motivo || motivo.trim().length < 3) {
            this.$swal.showValidationMessage(
              "Informe um motivo com pelo menos 3 caracteres."
            );
            return false;
          }

          return motivo.trim();
        },
      });

      if (!result.isConfirmed) return;

      await crmService.cancelarAgendamento({
        id_crm_agenda: agenda.id_crm_agenda,
        motivo_cancelamento: result.value,
      });
      this.$toast.success("Agendamento cancelado.");
      await this.afterAction();
    },
    async alterarStatusAgenda(agenda, status) {
      const result = await this.$swal.fire({
        icon: status === "cancelado" ? "warning" : "info",
        title: `${this.agendaStatusLabel(status)} este agendamento?`,
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      });

      if (!result.isConfirmed) return;

      await crmService.alterarStatusAgenda({
        id_crm_agenda: agenda.id_crm_agenda,
        status,
      });
      this.$toast.success("Agendamento atualizado.");
      await this.afterAction();
    },
    abrirModalLinkSolicitacaoTecnica(solicitacao) {
      const periodo = this.periodoLinkSolicitacaoTecnica();

      this.linkSolicitacaoOrigem = solicitacao;
      this.linkSolicitacaoGerado = this.linkPublicoSolicitacao(solicitacao);
      this.linkSolicitacaoForm = {
        data_inicio: solicitacao.link_data_inicio
          ? this.toDateInput(solicitacao.link_data_inicio)
          : periodo.data_inicio,
        data_fim: solicitacao.link_data_fim
          ? this.toDateInput(solicitacao.link_data_fim)
          : periodo.data_fim,
        duracao_minutos: solicitacao.link_duracao_minutos || 30,
        observacoes: solicitacao.observacoes || "",
      };
      this.$bvModal.show("crm-detalhe-link-solicitacao-modal");
    },
    async confirmarGerarLinkSolicitacaoTecnica() {
      if (!this.linkSolicitacaoOrigem) {
        return;
      }

      const duracao = Number(this.linkSolicitacaoForm.duracao_minutos || 0);

      if (
        !this.linkSolicitacaoForm.data_inicio ||
        !this.linkSolicitacaoForm.data_fim
      ) {
        this.$toast.error("Informe o período do link.");
        return;
      }

      if (
        this.linkSolicitacaoForm.data_inicio > this.linkSolicitacaoForm.data_fim
      ) {
        this.$toast.error(
          "A data final deve ser igual ou posterior à inicial."
        );
        return;
      }

      if (duracao < 1 || duracao > 1440) {
        this.$toast.error("Informe uma duração entre 1 minuto e 24 horas.");
        return;
      }

      this.linkSolicitacaoLoading = true;

      try {
        const { data } = await crmService.gerarLinkSolicitacaoTecnica({
          id_crm_solicitacao_tecnica:
            this.linkSolicitacaoOrigem.id_crm_solicitacao_tecnica,
          data_inicio: this.linkSolicitacaoForm.data_inicio,
          data_fim: this.linkSolicitacaoForm.data_fim,
          duracao_minutos: duracao,
          observacoes: this.linkSolicitacaoForm.observacoes,
        });
        const solicitacao = this.responseData(data);
        this.linkSolicitacaoOrigem = solicitacao || this.linkSolicitacaoOrigem;
        this.linkSolicitacaoGerado = this.linkPublicoSolicitacao(
          solicitacao || this.linkSolicitacaoOrigem
        );
        this.$toast.success("Link de horários gerado.");
        await this.afterAction();
      } catch (error) {
        this.$toast.error(
          this.apiError(error, "Não foi possível gerar o link.")
        );
      } finally {
        this.linkSolicitacaoLoading = false;
      }
    },
    linkPublicoSolicitacao(solicitacao) {
      if (!solicitacao) {
        return "";
      }

      const link =
        solicitacao.link_url ||
        solicitacao.url_publica ||
        (solicitacao.data ? solicitacao.data.url_publica : "");
      const token = solicitacao.link_token || solicitacao.token || "";

      return this.normalizarLinkPublicoAgenda(link, token);
    },
    normalizarLinkPublicoAgenda(link, token = "") {
      const texto = String(link || "").trim();
      const tokenLink = token || this.tokenLinkAgendaLegado(texto);

      if (!texto && tokenLink) {
        return `${window.location.origin}/#/agendamentos/publico/${tokenLink}`;
      }

      if (!texto.includes("/#/crm/agenda")) {
        return texto;
      }

      return tokenLink
        ? `${window.location.origin}/#/agendamentos/publico/${tokenLink}`
        : texto;
    },
    tokenLinkAgendaLegado(link) {
      const match = String(link || "").match(/[?&]solicitacao_tecnica=([^&]+)/);

      return match ? decodeURIComponent(match[1]) : "";
    },
    async copiarLinkSolicitacaoTecnica(solicitacao) {
      const link = this.linkPublicoSolicitacao(solicitacao);

      if (!link) {
        return;
      }

      await this.copiarTexto(link);
    },
    async copiarLinkSolicitacaoModal() {
      if (!this.linkSolicitacaoGerado) {
        return;
      }

      await this.copiarTexto(this.linkSolicitacaoGerado);
    },
    enviarLinkTecnicoWhatsapp(solicitacao) {
      const link = this.linkPublicoSolicitacao(solicitacao);

      if (!link || !this.contatoTelefone) {
        return;
      }

      const telefone = this.normalizarTelefoneWhatsapp(this.contatoTelefone);
      const mensagem = `Olá ${this.contatoPrincipal}, escolha um horário para sua apresentação técnica: ${link}`;
      window.open(
        `https://web.whatsapp.com/send?phone=${telefone}&text=${encodeURIComponent(
          mensagem
        )}`,
        "_blank",
        "noopener"
      );
    },
    enviarLinkSolicitacaoModalWhatsapp() {
      this.enviarLinkTecnicoWhatsapp({
        link_url: this.linkSolicitacaoGerado,
      });
    },
    enviarLinkTecnicoEmail(solicitacao) {
      const link = this.linkPublicoSolicitacao(solicitacao);

      if (!link || !this.contatoEmail) {
        return;
      }

      const assunto = encodeURIComponent("Horários para apresentação técnica");
      const corpo = encodeURIComponent(
        `Olá ${this.contatoPrincipal},\n\nEscolha um horário para sua apresentação técnica pelo link:\n${link}`
      );
      window.open(
        `mailto:${this.contatoEmail}?subject=${assunto}&body=${corpo}`,
        "_blank",
        "noopener"
      );
    },
    enviarLinkSolicitacaoModalEmail() {
      this.enviarLinkTecnicoEmail({
        link_url: this.linkSolicitacaoGerado,
      });
    },
    async concluirTarefa(tarefa) {
      if (this.isTarefaContrato(tarefa)) {
        await this.loadOportunidade();
        await this.abrirModalResponsaveisContrato(tarefa);
        return;
      }

      await this.concluirTarefaComPayload(tarefa);
    },
    async concluirTarefaComPayload(tarefa, payload = {}) {
      await crmService.concluirAtividade({
        id_crm_atividade: tarefa.id_crm_atividade,
        ...payload,
      });
      this.$toast.success("Tarefa concluída.");
      await this.afterAction();
    },
    async confirmarConclusaoContrato() {
      if (!this.contratoResponsaveisTarefa) {
        return;
      }

      if (
        this.contratoExigeImplementacaoWhiteLabel &&
        !this.contratoResponsaveisForm.id_usuario_white_label
      ) {
        this.$toast.error(
          "Selecione o responsável pela implementação White Label."
        );
        return;
      }

      if (
        this.contratoExigeTreinamento &&
        !this.contratoResponsaveisForm.id_usuario_treinamento
      ) {
        this.$toast.error("Selecione o responsável pelo treinamento.");
        return;
      }

      if (
        this.contratoExigeTreinamentoClienteFinal &&
        !this.contratoResponsaveisForm.id_usuario_treinamento_cliente_final
      ) {
        this.$toast.error(
          "Selecione o responsável pelo Treinamento Cliente Final."
        );
        return;
      }

      if (
        this.contratoExigeWebsite &&
        !this.contratoResponsaveisForm.id_usuario_website
      ) {
        this.$toast.error("Selecione o responsável pelo website.");
        return;
      }

      this.contratoResponsaveisLoading = true;

      try {
        await this.concluirTarefaComPayload(this.contratoResponsaveisTarefa, {
          id_usuario_white_label: this.contratoExigeImplementacaoWhiteLabel
            ? this.contratoResponsaveisForm.id_usuario_white_label
            : null,
          id_usuario_treinamento: this.contratoExigeTreinamento
            ? this.contratoResponsaveisForm.id_usuario_treinamento
            : null,
          id_usuario_treinamento_cliente_final: this
            .contratoExigeTreinamentoClienteFinal
            ? this.contratoResponsaveisForm.id_usuario_treinamento_cliente_final
            : null,
          id_usuario_website: this.contratoExigeWebsite
            ? this.contratoResponsaveisForm.id_usuario_website
            : null,
        });
        this.$bvModal.hide("crm-detalhe-responsaveis-contrato-modal");
        this.contratoResponsaveisTarefa = null;
        this.contratoResponsaveisForm = this.emptyContratoResponsaveisForm();
      } finally {
        this.contratoResponsaveisLoading = false;
      }
    },
    abrirModalGanho() {
      const clienteFinal = this.oportunidadeVendaClienteFinal();
      const enderecoPessoa = this.enderecoPessoaOportunidade(this.oportunidade);
      this.ganhoForm = {
        ...this.emptyGanhoForm(),
        titulo: this.oportunidade.titulo || "",
        cliente: this.contatoPrincipal,
        nome_correto: this.nomeClienteFechamento,
        cnpj: this.documentoClienteFechamento,
        email_cliente: this.oportunidade.contato_email || "",
        telefone_cliente: this.contatoTelefone || "",
        endereco_cliente:
          this.valorCampoComercial(this.oportunidade, "endereco_cliente") ||
          this.enderecoFechamentoCompleto(enderecoPessoa),
        ...enderecoPessoa,
        valor_final:
          this.valorFinalDetalhe || this.oportunidade.valor_estimado || 0,
        beneficios: this.beneficiosLivresOportunidade(),
        beneficios_livres: this.beneficiosLivresOportunidade(),
        beneficios_estruturados: clienteFinal
          ? ["treinamento_cliente_final"]
          : this.beneficiosEstruturadosOportunidade(),
        cliente_final: clienteFinal,
      };
      this.$bvModal.show("crm-detalhe-ganho-modal");
    },
    validarGanho() {
      this.ganhoForm.endereco_cliente = this.enderecoFechamentoCompleto(
        this.ganhoForm
      );

      if (!(this.ganhoForm.nome_correto || "").trim()) {
        this.$toast.error("Informe o nome correto do cliente.");
        return false;
      }

      if (this.somenteNumeros(this.ganhoForm.cnpj).length !== 14) {
        this.$toast.error("Informe um CNPJ válido.");
        return false;
      }

      if (!(this.ganhoForm.email_cliente || "").trim()) {
        this.$toast.error("Informe o e-mail do cliente.");
        return false;
      }

      if (!this.validarEnderecoGanho(this.ganhoForm)) {
        return false;
      }

      if (Number(this.ganhoForm.valor_final || 0) <= 0) {
        this.$toast.error("Informe o valor final.");
        return false;
      }

      if (
        !this.ganhoForm.cliente_final &&
        !this.beneficiosEstruturadosLista(
          this.ganhoForm.beneficios_estruturados
        ).length
      ) {
        this.$toast.error("Selecione pelo menos um benefício de regra.");
        return false;
      }

      return true;
    },
    async marcarGanha() {
      if (!this.validarGanho()) {
        return;
      }

      await crmService.marcarGanha({
        id_crm_oportunidade: this.idOportunidade,
        fechamento: {
          nome_correto: (this.ganhoForm.nome_correto || "").trim(),
          cnpj: this.ganhoForm.cnpj,
          email_cliente: (this.ganhoForm.email_cliente || "").trim(),
          telefone_cliente: (this.ganhoForm.telefone_cliente || "").trim(),
          endereco_cliente: (this.ganhoForm.endereco_cliente || "").trim(),
          cep: this.ganhoForm.cep,
          logradouro: this.ganhoForm.logradouro,
          numero: this.ganhoForm.numero,
          bairro: this.ganhoForm.bairro,
          complemento: this.ganhoForm.complemento,
          id_cidade: this.ganhoForm.id_cidade,
          valor_final: Number(this.ganhoForm.valor_final || 0),
          beneficios: (this.ganhoForm.beneficios_livres || "").trim(),
          beneficios_livres: (this.ganhoForm.beneficios_livres || "").trim(),
          beneficios_estruturados: this.ganhoForm.cliente_final
            ? ["treinamento_cliente_final"]
            : this.beneficiosEstruturadosLista(
                this.ganhoForm.beneficios_estruturados
              ),
        },
      });
      this.$toast.success("Oportunidade marcada como ganha.");
      this.$bvModal.hide("crm-detalhe-ganho-modal");
      this.afterAction();
    },
    abrirModalPerda() {
      this.perdaForm = this.emptyPerdaForm();
      this.$bvModal.show("crm-detalhe-perda-modal");
    },
    async marcarPerdida() {
      if (!this.perdaForm.id_crm_motivo_perda) {
        this.$toast.error("Informe o motivo da perda.");
        return;
      }

      await crmService.marcarPerdida({
        id_crm_oportunidade: this.idOportunidade,
        ...this.perdaForm,
      });
      this.$toast.success("Oportunidade marcada como perdida.");
      this.$bvModal.hide("crm-detalhe-perda-modal");
      this.afterAction();
    },
    async afterAction() {
      await this.loadOportunidade();
      await Promise.allSettled([
        this.loadTimeline(true),
        this.loadRelacionados(),
      ]);
    },
    erroMensagem(error, fallback) {
      const response = error && error.response ? error.response.data : null;

      return (
        (response && (response.msg || response.message)) ||
        (error && error.message) ||
        fallback
      );
    },
    focusNota() {
      this.activeTab = 3;
      this.$nextTick(() => {
        if (this.$refs.notaInput) {
          this.$refs.notaInput.focus();
        }
      });
    },
    normalizeCollection(data) {
      if (Array.isArray(data)) {
        return data;
      }

      if (data && Array.isArray(data.data)) {
        return data.data;
      }

      return [];
    },
    responseData(response) {
      const body = response && response.data ? response.data : response;
      if (body && body.status === false) {
        throw new Error(
          body.msg || body.message || "Não foi possível concluir a operação."
        );
      }
      return body && body.data ? body.data : body;
    },
    booleanFlag(value) {
      if (value === true || value === 1) {
        return true;
      }

      if (typeof value === "string") {
        return ["1", "true", "sim", "yes", "t"].includes(value.toLowerCase());
      }

      return false;
    },
    optionText(options, value) {
      const option = (options || []).find(
        (item) => String(item.value) === String(value)
      );

      return option ? option.text : null;
    },
    vendedoresFromAtribuicoes(response) {
      return this.usuariosPorPapelFromAtribuicoes(response, "vendedor");
    },
    desenvolvedoresFromAtribuicoes(response) {
      return this.usuariosPorPapelFromAtribuicoes(response, "desenvolvedor");
    },
    usuariosPorPapelFromAtribuicoes(response, papel) {
      const data = this.responseData(response);
      const usuarios =
        data && Array.isArray(data.usuarios) ? data.usuarios : [];

      return usuarios.filter((usuario) => {
        const papeis = Array.isArray(usuario.papeis_crm)
          ? usuario.papeis_crm
          : [];

        return usuario.selecionado || papeis.includes(papel);
      });
    },
    usuarioPorId(idUsuario) {
      const id = Number(idUsuario);
      const listas = [
        this.usuarios,
        this.vendedoresAtribuicao,
        this.desenvolvedoresAtribuicao,
        this.treinamentoAtribuicao,
      ];

      return listas
        .flat()
        .find((usuario) => Number(usuario.id_usuario) === id);
    },
    usuarioPossuiPapelCrm(idUsuario, papel) {
      const usuario = this.usuarioPorId(idUsuario);
      const papeis = Array.isArray(usuario && usuario.papeis_crm)
        ? usuario.papeis_crm
        : [];

      return papeis.includes(papel);
    },
    funilAtualChavePreset() {
      if (!this.oportunidade) {
        return null;
      }

      const funil = this.funis.find(
        (item) =>
          Number(item.id_crm_funil) === Number(this.oportunidade.id_crm_funil)
      );

      return funil ? funil.chave_preset : null;
    },
    usuarioTemAcessoPorPapelAoFunilAtual(idUsuario) {
      const mapa = {
        vendas: ["vendedor", "desenvolvedor"],
        vendas_cliente_final: ["vendedor", "desenvolvedor"],
        pos_venda: ["vendedor"],
        implementacao_white_label: ["desenvolvedor"],
        treinamento_cliente_final: ["treinamento_cliente_final", "treinamento"],
        treinamento: ["treinamento"],
        website: ["website"],
      };
      const papeis = mapa[this.funilAtualChavePreset()] || [];

      return papeis.some((papel) => this.usuarioPossuiPapelCrm(idUsuario, papel));
    },
    isTreinamentoClienteFinal(oportunidade) {
      return (
        oportunidade && oportunidade.tipo_fluxo === "treinamento_cliente_final"
      );
    },
    idPrimeiroResponsavelTreinamento() {
      const primeiro = this.treinamentoResponsavelOptions.find(
        (option) => option.value
      );

      return primeiro ? primeiro.value : null;
    },
    timelinePayload(item) {
      if (!item.payload) {
        return {};
      }

      if (typeof item.payload === "object") {
        return item.payload;
      }

      try {
        return JSON.parse(item.payload);
      } catch (error) {
        return {};
      }
    },
    timelineAgendavel(item) {
      return (
        item.tipo_evento === "atividade_criada" &&
        !!this.timelinePayload(item).id_crm_atividade
      );
    },
    agendarTarefaTimeline(item) {
      this.abrirModalAgenda(this.timelinePayload(item));
    },
    timelineAnexoUrl(item) {
      return this.timelinePayload(item).url || "";
    },
    timelineAnexoNome(item) {
      return this.timelinePayload(item).nome || "anexo";
    },
    tipoTarefaLabel(chave) {
      const tipo = this.tiposTarefa.find((item) => item.chave === chave);
      return tipo ? tipo.nome : chave || "-";
    },
    tipoAgendaLabel(chave) {
      const tipo = this.tipoAgendaOptions.find((item) => item.value === chave);
      return tipo ? tipo.text : chave || "-";
    },
    etapaOptions(idFunil) {
      const funil = this.funis.find((item) => item.id_crm_funil === idFunil);
      const etapas = funil && Array.isArray(funil.etapas) ? funil.etapas : [];

      return etapas.map((etapa) => ({
        value: etapa.id_crm_etapa,
        text: etapa.nome,
      }));
    },
    findEtapaById(idEtapa) {
      if (!idEtapa) {
        return null;
      }

      for (const funil of this.funis) {
        const etapas = funil.etapas || [];
        const etapa = etapas.find(
          (item) => item.id_crm_etapa === Number(idEtapa)
        );

        if (etapa) {
          return etapa;
        }
      }

      if (
        this.oportunidade &&
        Number(this.oportunidade.id_crm_etapa) === Number(idEtapa)
      ) {
        return {
          id_crm_etapa: this.oportunidade.id_crm_etapa,
          nome: this.oportunidade.etapa,
        };
      }

      return null;
    },
    camposObrigatoriosEtapa(etapa, contexto = "entrada_etapa") {
      if (!etapa) {
        return [];
      }

      return (
        etapa.campos_obrigatorios ||
        etapa.camposObrigatorios ||
        []
      ).filter(
        (regra) =>
          regra.ativo !== false &&
          (!regra.contexto || regra.contexto === contexto)
      );
    },
    campoObrigatorioConfig(regra) {
      return regra.campo || regra.campo_comercial || {};
    },
    campoObrigatorioChave(regra) {
      return this.campoObrigatorioConfig(regra).chave || regra.chave || "";
    },
    campoObrigatorioTipo(regra) {
      return this.campoObrigatorioConfig(regra).tipo || regra.tipo || "texto";
    },
    isCampoObrigatorioMonetario(regra) {
      return [
        "valor_estimado",
        "valor_proposta",
        "valor_negociacao",
        "valor_final",
      ].includes(this.campoObrigatorioChave(regra));
    },
    labelCampoObrigatorio(regra) {
      return this.campoObrigatorioConfig(regra).nome || regra.nome || "Campo";
    },
    campoObrigatorioOptions(regra) {
      const opcoes = this.campoObrigatorioConfig(regra).opcoes || [];
      const valores = Array.isArray(opcoes)
        ? opcoes
        : this.parseCampoObrigatorioOpcoes(opcoes);

      return [{ value: null, text: "Selecione" }].concat(
        valores.map((valor) =>
          typeof valor === "object"
            ? {
                value: valor.value || valor.valor || valor.label,
                text: valor.label || valor.text || valor.valor,
              }
            : { value: valor, text: valor }
        )
      );
    },
    parseCampoObrigatorioOpcoes(opcoes) {
      const texto = String(opcoes || "");

      if (!texto) {
        return [];
      }

      try {
        const parsed = JSON.parse(texto);
        if (Array.isArray(parsed)) {
          return parsed;
        }
      } catch (error) {
        // Campo legado pode vir como texto livre separado por linha.
      }

      return texto.split("\n").filter(Boolean);
    },
    slugEtapa(nome) {
      return String(nome || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "_")
        .replace(/^_|_$/g, "");
    },
    etapaPossuiChave(etapa, chave) {
      if (!etapa) {
        return false;
      }

      const chaves = [etapa.chave_preset, etapa.chave, etapa.nome].map(
        (valor) => this.slugEtapa(valor)
      );

      return chaves.includes(chave);
    },
    oportunidadeTemVendedorResponsavel(oportunidade = {}) {
      return !!(
        oportunidade &&
        (oportunidade.id_vendedor_responsavel ||
          this.valorCampoComercial(oportunidade, "id_vendedor_responsavel"))
      );
    },
    oportunidadeTemResponsavelTecnico(oportunidade = {}) {
      return !!(
        oportunidade &&
        (oportunidade.id_responsavel_tecnico ||
          this.valorCampoComercial(oportunidade, "id_responsavel_tecnico"))
      );
    },
    isEtapaApresentacaoTecnica(etapa) {
      if (!etapa) {
        return false;
      }

      return (
        etapa.chave_preset === "apresentacao_tecnica" ||
        this.slugEtapa(etapa.nome) === "apresentacao_tecnica"
      );
    },
    movimentoExigeAtribuicaoParaDestino(etapaDestino) {
      return (
        !this.oportunidadeTemVendedorResponsavel(this.oportunidade) &&
        this.etapaPossuiChave(this.etapaAtualConfig, "primeiro_contato") &&
        this.etapaPossuiChave(etapaDestino, "qualificacao")
      );
    },
    deveAbrirModalMovimento(etapaDestino) {
      return (
        this.camposObrigatoriosEtapa(etapaDestino).length > 0 ||
        (!this.oportunidadeTemResponsavelTecnico(this.oportunidade) &&
          this.isEtapaApresentacaoTecnica(etapaDestino)) ||
        this.movimentoExigeAtribuicaoParaDestino(etapaDestino)
      );
    },
    prepararCamposMovimento() {
      const form = {};

      this.camposObrigatoriosMovimento.forEach((regra) => {
        const idCampo = regra.id_crm_campo_comercial;
        let valor = this.movimentoCamposForm[idCampo] || "";

        if (
          this.movimentoManterValor &&
          this.campoObrigatorioChave(regra) === "valor_negociacao"
        ) {
          valor = this.valorPadraoNegociacao();
        }

        this.$set(form, idCampo, valor);
      });

      this.movimentoCamposForm = form;
    },
    valorPadraoNegociacao() {
      const valor =
        this.valorCampoComercial(this.oportunidade, "valor_proposta") ||
        this.oportunidade.valor_estimado;
      const numero = Number(valor || 0);

      return numero ? numero.toFixed(2) : "";
    },
    validarCamposMovimento() {
      if (this.movimentoExigeAtribuicao && !this.idUsuarioDestino) {
        this.$toast.error(
          "Selecione o vendedor responsável pela oportunidade."
        );
        return false;
      }

      if (this.movimentoExigeTecnico && !this.idUsuarioTecnicoDestino) {
        this.$toast.error(
          "Selecione o desenvolvedor responsável pela apresentação técnica."
        );
        return false;
      }

      if (this.usuarioDestinoSemAcesso && !this.concederAcessoFunilDestino) {
        this.$toast.error(
          "O usuário escolhido ainda não tem acesso ao funil atual."
        );
        return false;
      }

      const faltante = this.camposObrigatoriosMovimento.find((regra) => {
        const valor =
          this.movimentoCamposForm[regra.id_crm_campo_comercial] || "";
        return String(valor).trim() === "";
      });

      if (faltante) {
        this.$toast.error(
          faltante.mensagem ||
            `Preencha o campo obrigatório: ${this.labelCampoObrigatorio(
              faltante
            )}.`
        );
        return false;
      }

      return true;
    },
    movimentoCamposPayload() {
      return this.camposObrigatoriosMovimento.map((regra) => ({
        id_crm_campo_comercial: regra.id_crm_campo_comercial,
        valor: this.movimentoCamposForm[regra.id_crm_campo_comercial],
      }));
    },
    tentarMoverEtapaDetalhe(etapa) {
      if (
        !this.oportunidade ||
        this.stageChanging ||
        this.oportunidade.status !== "aberta" ||
        !etapa ||
        etapa.id_crm_etapa === this.oportunidade.id_crm_etapa
      ) {
        return;
      }

      if (this.deveAbrirModalMovimento(etapa)) {
        this.abrirModalMoverDetalhe(etapa.id_crm_etapa);
        return;
      }

      this.moverEtapaDetalhe(etapa.id_crm_etapa);
    },
    abrirModalMoverDetalhe(idEtapaDestino) {
      this.idEtapaDestino = idEtapaDestino;
      this.idUsuarioTecnicoDestino = null;
      this.idUsuarioDestino = null;
      this.concederAcessoFunilDestino = false;
      this.movimentoCamposForm = {};
      this.movimentoManterValor = true;
      this.prepararCamposMovimento();
      this.$bvModal.show("crm-detalhe-mover-etapa-modal");
    },
    confirmarMoverEtapaDetalhe() {
      if (
        !this.idEtapaDestino ||
        this.idEtapaDestino === this.oportunidade.id_crm_etapa
      ) {
        this.$bvModal.hide("crm-detalhe-mover-etapa-modal");
        return;
      }

      this.prepararCamposMovimento();

      if (!this.validarCamposMovimento()) {
        return;
      }

      this.moverEtapaDetalhe(this.idEtapaDestino, {
        id_usuario_tecnico: this.movimentoExigeTecnico
          ? this.idUsuarioTecnicoDestino
          : null,
        id_usuario_destino: this.movimentoExigeAtribuicao
          ? this.idUsuarioDestino
          : null,
        id_vendedor_responsavel: this.movimentoExigeAtribuicao
          ? this.idUsuarioDestino
          : null,
        conceder_acesso_funil: this.concederAcessoFunilDestino,
        campos_comerciais: this.movimentoCamposPayload(),
      });
    },
    async moverEtapaDetalhe(idEtapaDestino, extraPayload = {}) {
      this.stageChanging = true;

      try {
        await crmService.moverEtapa({
          id_crm_oportunidade: this.idOportunidade,
          id_crm_etapa: idEtapaDestino,
          ...extraPayload,
        });
        this.$toast.success("Etapa alterada.");
        this.$bvModal.hide("crm-detalhe-mover-etapa-modal");
        await this.afterAction();
      } catch (error) {
        this.$toast.error(
          this.apiError(error, "Não foi possível alterar a etapa.")
        );
      } finally {
        this.stageChanging = false;
      }
    },
    temperaturaLabel(valor) {
      const option = this.temperaturaOptions.find(
        (item) => item.value === valor
      );

      return option ? option.text : valor || "-";
    },
    temperaturaOption(valor) {
      return this.temperaturaOptions.find((item) => item.value === valor);
    },
    temperaturaIcon(valor) {
      const icons = {
        muito_frio: "la la-thermometer-empty",
        frio: "la la-thermometer-quarter",
        morno: "la la-thermometer-half",
        quente: "la la-thermometer-three-quarters",
        venda_certa: "la la-thermometer-full",
      };

      return icons[valor] || "la la-thermometer-empty";
    },
    temperaturaColor(valor) {
      const option = this.temperaturaOption(valor);

      return option && option.cor ? option.cor : "#7e8299";
    },
    abrirModalTemperaturaDetalhe() {
      this.temperaturaForm = {
        temperatura: this.oportunidade.temperatura || null,
      };
      this.$bvModal.show("crm-detalhe-temperatura-modal");
    },
    async salvarTemperaturaDetalhe() {
      try {
        await crmService.atualizarOportunidade({
          id_crm_oportunidade: this.idOportunidade,
          temperatura: this.temperaturaForm.temperatura || null,
        });
        this.$toast.success("Temperatura atualizada.");
        this.$bvModal.hide("crm-detalhe-temperatura-modal");
        await this.afterAction();
      } catch (error) {
        this.$toast.error(
          this.apiError(error, "Não foi possível atualizar a temperatura.")
        );
      }
    },
    temperaturaOptionsFromList(temperaturas) {
      const ativos = temperaturas.filter((item) => item.ativo !== false);

      if (!ativos.length) {
        return this.temperaturaOptions;
      }

      return [{ value: null, text: "Sem temperatura" }].concat(
        ativos.map((item) => ({
          value: item.chave,
          text: item.nome,
          cor: item.cor,
        }))
      );
    },
    campoComercialOptions(campo) {
      const opcoes = String(campo.opcoes || "")
        .split(/\r?\n/)
        .map((item) => item.trim())
        .filter(Boolean);

      return [{ value: "", text: "Selecione" }].concat(
        opcoes.map((item) => ({ value: item, text: item }))
      );
    },
    campoInputType(campo) {
      if (campo.tipo === "numero") {
        return "number";
      }

      if (campo.tipo === "data") {
        return "date";
      }

      return "text";
    },
    campoValorLabel(campo) {
      if (
        campo.valor === null ||
        campo.valor === undefined ||
        campo.valor === ""
      ) {
        return "-";
      }

      if (campo.tipo === "booleano") {
        return String(campo.valor) === "1" ? "Sim" : "Não";
      }

      if (campo.chave === "beneficios" || campo.chave === "beneficios_livres") {
        return String(campo.valor || "").trim() || "-";
      }

      if (campo.chave === "beneficios_estruturados") {
        return (
          this.beneficiosEstruturadosLista(campo.valor)
            .map((item) => this.beneficioLabel(item))
            .join(", ") || "-"
        );
      }

      return String(campo.valor);
    },
    beneficiosTexto(value) {
      let valores = value;

      if (typeof valores === "string") {
        const trimmed = valores.trim();
        if (!trimmed) {
          return "";
        }

        try {
          const parsed = JSON.parse(trimmed);
          valores = Array.isArray(parsed) ? parsed : trimmed;
        } catch (error) {
          valores = trimmed;
        }
      }

      if (!Array.isArray(valores)) {
        valores = String(valores || "")
          .split(/[,;\n]+/)
          .map((item) => item.trim());
      }

      return this.normalizarBeneficiosLista(valores).join(", ");
    },
    beneficiosLista(value) {
      let valores = value;

      if (typeof valores === "string") {
        const trimmed = valores.trim();
        if (!trimmed) {
          return [];
        }

        try {
          const parsed = JSON.parse(trimmed);
          valores = Array.isArray(parsed) ? parsed : trimmed;
        } catch (error) {
          valores = trimmed;
        }
      }

      if (!Array.isArray(valores)) {
        valores = String(valores || "")
          .split(/[,;\n]+/)
          .map((item) => item.trim());
      }

      return this.normalizarBeneficiosLista(valores);
    },
    normalizarBeneficiosLista(valores) {
      const lista = valores
        .map((item) => this.beneficioLabel(item))
        .filter(Boolean)
        .filter((item, index, array) => array.indexOf(item) === index);

      return lista.includes("Treinamento Cliente Final")
        ? lista.filter((item) => item !== "Treinamento")
        : lista;
    },
    beneficioLabel(value) {
      const text = String(value || "").trim();
      if (!text) {
        return "";
      }

      const key = text
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "_")
        .replace(/^_+|_+$/g, "");
      const labels = {
        website: "Website",
        web_site: "Website",
        site: "Website",
        treinamento: "Treinamento",
        treinamento_cliente_final: "Treinamento Cliente Final",
        treinamento_final: "Treinamento Cliente Final",
        cliente_final: "Treinamento Cliente Final",
        desconto: "Desconto",
        implantacao: "Implementação White Label",
        implementacao: "Implementação White Label",
        implantacao_white_label: "Implementação White Label",
        implementacao_white_label: "Implementação White Label",
        white_label: "Implementação White Label",
        suporte_estendido: "Suporte estendido",
      };

      return labels[key] || text.replace(/_/g, " ");
    },
    beneficioKey(value) {
      const text = String(value || "").trim();
      if (!text) {
        return "";
      }

      const key = text
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "_")
        .replace(/^_+|_+$/g, "");
      const keys = {
        website: "website",
        web_site: "website",
        site: "website",
        implantacao: "implementacao_white_label",
        implementacao: "implementacao_white_label",
        implantacao_white_label: "implementacao_white_label",
        implementacao_white_label: "implementacao_white_label",
        white_label: "implementacao_white_label",
        treinamento_cliente_final: "treinamento_cliente_final",
        treinamento_final: "treinamento_cliente_final",
        cliente_final: "treinamento_cliente_final",
      };

      return keys[key] || "";
    },
    beneficiosEstruturadosLista(value) {
      let valores = value;

      if (typeof valores === "string") {
        const trimmed = valores.trim();
        if (!trimmed) {
          return [];
        }

        try {
          const parsed = JSON.parse(trimmed);
          valores = Array.isArray(parsed) ? parsed : trimmed;
        } catch (error) {
          valores = trimmed;
        }
      }

      if (!Array.isArray(valores)) {
        valores = String(valores || "")
          .split(/[,;\n]+/)
          .map((item) => item.trim());
      }

      const permitidos = this.beneficioOptions.map((item) => item.value);
      return valores
        .map((item) => this.beneficioKey(item))
        .filter((item) => permitidos.includes(item))
        .filter((item, index, array) => array.indexOf(item) === index);
    },
    beneficiosEstruturadosOportunidade() {
      const valorEstruturado = this.valorCampoComercial(
        this.oportunidade,
        "beneficios_estruturados"
      );
      const lista = this.beneficiosEstruturadosLista(valorEstruturado);

      if (lista.length || valorEstruturado) {
        return lista;
      }

      return this.beneficiosEstruturadosLista(
        this.valorCampoComercial(this.oportunidade, "beneficios")
      );
    },
    beneficiosLivresOportunidade() {
      return String(
        this.valorCampoComercial(this.oportunidade, "beneficios_livres") ||
          this.valorCampoComercial(this.oportunidade, "beneficios") ||
          ""
      ).trim();
    },
    beneficioEstruturadoSelecionado(value) {
      return this.beneficiosEstruturadosLista(
        this.ganhoForm.beneficios_estruturados
      ).includes(value);
    },
    toggleBeneficioGanho(value) {
      const key = this.beneficioKey(value);
      if (!key) {
        return;
      }

      let atuais = this.beneficiosEstruturadosLista(
        this.ganhoForm.beneficios_estruturados
      );

      if (atuais.includes(key)) {
        this.ganhoForm.beneficios_estruturados = atuais.filter(
          (item) => item !== key
        );
        return;
      }

      if (key === "treinamento_cliente_final") {
        this.ganhoForm.beneficios_estruturados = [key];
        return;
      }

      atuais = atuais.filter((item) => item !== "treinamento_cliente_final");
      atuais.push(key);
      this.ganhoForm.beneficios_estruturados = atuais;
    },
    beneficioCampoSelecionado(idCampo, value) {
      return this.beneficiosEstruturadosLista(
        this.dadosForm.campos_comerciais[idCampo]
      ).includes(value);
    },
    toggleBeneficioCampo(idCampo, value) {
      const key = this.beneficioKey(value);
      if (!key) {
        return;
      }

      let atuais = this.beneficiosEstruturadosLista(
        this.dadosForm.campos_comerciais[idCampo]
      );

      if (atuais.includes(key)) {
        this.$set(
          this.dadosForm.campos_comerciais,
          idCampo,
          atuais.filter((item) => item !== key)
        );
        return;
      }

      if (key === "treinamento_cliente_final") {
        this.$set(this.dadosForm.campos_comerciais, idCampo, [key]);
        return;
      }

      atuais = atuais.filter((item) => item !== "treinamento_cliente_final");
      atuais.push(key);
      this.$set(this.dadosForm.campos_comerciais, idCampo, atuais);
    },
    adicionarBeneficioGanho(label) {
      this.toggleBeneficioGanho(label);
    },
    adicionarBeneficioCampo(idCampo, label) {
      this.toggleBeneficioCampo(idCampo, label);
    },
    async consultarCnpjFechamento() {
      if (this.somenteNumeros(this.ganhoForm.cnpj).length !== 14) {
        this.$toast.warning("Informe um CNPJ válido para consultar.");
        return;
      }

      this.loadingConsultaCnpjFechamento = true;

      try {
        const receita = await this.getConsultaReceita(this.ganhoForm.cnpj);
        this.aplicarReceitaFechamento(receita);
        this.$toast.success(
          "Dados do CNPJ carregados. Confira antes de fechar."
        );
      } catch (error) {
        this.$toast.warning(
          this.apiError(error, "Não foi possível consultar o CNPJ.")
        );
      } finally {
        this.loadingConsultaCnpjFechamento = false;
      }
    },
    aplicarReceitaFechamento(receita = {}) {
      this.ganhoForm.nome_correto =
        receita.nome || this.ganhoForm.nome_correto || "";

      if (receita.email && receita.email.email) {
        this.ganhoForm.email_cliente = receita.email.email;
      }

      if (receita.telefone && receita.telefone.fone) {
        this.ganhoForm.telefone_cliente = receita.telefone.fone;
      }

      if (receita.endereco && receita.endereco.cep) {
        this.ganhoForm.cep = receita.endereco.cep || "";
        this.ganhoForm.logradouro = receita.endereco.logradouro || "";
        this.ganhoForm.numero = receita.endereco.numero || "";
        this.ganhoForm.bairro = receita.endereco.bairro || "";
        this.ganhoForm.complemento = receita.endereco.complemento || "";
        this.ganhoForm.id_cidade = receita.endereco.id_cidade || null;
        this.ganhoForm.cidade =
          receita.endereco.cidade && receita.endereco.cidade.cidade
            ? receita.endereco.cidade.cidade
            : "";
        this.ganhoForm.uf =
          receita.endereco.cidade && receita.endereco.cidade.uf
            ? receita.endereco.cidade.uf
            : "";
        this.ganhoForm.endereco_cliente = this.enderecoFechamentoCompleto(
          this.ganhoForm
        );
      }
    },
    async consultarCepFechamento() {
      if (this.somenteNumeros(this.ganhoForm.cep).length !== 8) {
        this.$toast.warning("Informe um CEP válido para consultar.");
        return;
      }

      this.loadingConsultaCepFechamento = true;

      try {
        const cep = await this.getCep(this.ganhoForm.cep);

        if (!cep || Array.isArray(cep) || cep.erro) {
          this.$toast.warning("Confira o CEP informado.");
          return;
        }

        this.ganhoForm.logradouro = cep.logradouro || "";
        this.ganhoForm.bairro = cep.bairro || "";
        this.ganhoForm.complemento = cep.complemento || "";
        this.ganhoForm.cep = cep.cep || this.ganhoForm.cep;

        const cidade = await this.getCidadeByUF(cep.localidade, cep.uf);
        const cidadeSelecionada = this.primeiraCidadeConsulta(cidade);
        this.ganhoForm.id_cidade = cidadeSelecionada
          ? cidadeSelecionada.id_cidade
          : null;
        this.ganhoForm.cidade = cidadeSelecionada
          ? cidadeSelecionada.cidade
          : cep.localidade || "";
        this.ganhoForm.uf = cidadeSelecionada
          ? cidadeSelecionada.uf
          : cep.uf || "";
        this.ganhoForm.endereco_cliente = this.enderecoFechamentoCompleto(
          this.ganhoForm
        );
        this.$toast.success("Endereço carregado pelo CEP.");
      } catch (error) {
        this.$toast.warning(
          this.apiError(error, "Não foi possível consultar o CEP.")
        );
      } finally {
        this.loadingConsultaCepFechamento = false;
      }
    },
    primeiraCidadeConsulta(cidade) {
      return Array.isArray(cidade) ? cidade[0] : cidade;
    },
    enderecoPessoaOportunidade(oportunidade) {
      return {
        cep: oportunidade.pessoa_endereco_cep || "",
        logradouro: oportunidade.pessoa_endereco_logradouro || "",
        numero: oportunidade.pessoa_endereco_numero || "",
        bairro: oportunidade.pessoa_endereco_bairro || "",
        complemento: oportunidade.pessoa_endereco_complemento || "",
        id_cidade: oportunidade.pessoa_endereco_id_cidade || null,
        cidade: oportunidade.pessoa_endereco_cidade || "",
        uf: oportunidade.pessoa_endereco_uf || "",
      };
    },
    validarEnderecoGanho(form) {
      const enderecoTexto = (form.endereco_cliente || "").trim();
      const camposEstruturados = [
        form.cep,
        form.id_cidade,
        form.logradouro,
        form.numero,
        form.bairro,
      ];
      const temCampoEstruturado = camposEstruturados.some((valor) =>
        (valor || "").toString().trim()
      );

      if (!enderecoTexto && !temCampoEstruturado) {
        this.$toast.error("Informe o endereço do cliente.");
        return false;
      }

      if (!temCampoEstruturado && enderecoTexto) {
        return true;
      }

      if (this.somenteNumeros(form.cep).length !== 8) {
        this.$toast.error("Informe um CEP válido.");
        return false;
      }

      if (!form.id_cidade) {
        this.$toast.error("Informe a cidade do cliente pelo CEP.");
        return false;
      }

      if (!(form.logradouro || "").trim()) {
        this.$toast.error("Informe o logradouro do cliente.");
        return false;
      }

      if (!(form.numero || "").trim()) {
        this.$toast.error("Informe o número do endereço do cliente.");
        return false;
      }

      if (!(form.bairro || "").trim()) {
        this.$toast.error("Informe o bairro do cliente.");
        return false;
      }

      return true;
    },
    enderecoFechamentoCompleto(form) {
      const endereco = [
        form.logradouro,
        form.numero ? `nº ${form.numero}` : null,
        form.bairro,
        [form.cidade, form.uf].filter(Boolean).join(" / "),
        form.cep ? `CEP ${form.cep}` : null,
      ]
        .filter(Boolean)
        .join(", ");

      return endereco || form.endereco_cliente || "";
    },
    camposComerciaisFormValues() {
      return this.camposComerciaisDetalhe.reduce((values, campo) => {
        if (campo.chave === "beneficios_estruturados") {
          values[campo.id_crm_campo_comercial] =
            this.beneficiosEstruturadosLista(campo.valor);
          return values;
        }

        values[campo.id_crm_campo_comercial] =
          campo.valor === null || campo.valor === undefined ? "" : campo.valor;

        return values;
      }, {});
    },
    camposComerciaisPayload() {
      return this.camposComerciaisDetalhe.map((campo) => {
        const valor =
          this.dadosForm.campos_comerciais[campo.id_crm_campo_comercial];

        return {
          id_crm_campo_comercial: campo.id_crm_campo_comercial,
          valor: this.normalizarValorCampoComercialPayload(campo, valor),
        };
      });
    },
    normalizarValorCampoComercialPayload(campo, valor) {
      if (campo.chave === "beneficios_estruturados") {
        const beneficios = this.beneficiosEstruturadosLista(valor);
        return beneficios.length ? beneficios : null;
      }

      if (campo.chave === "beneficios" || campo.chave === "beneficios_livres") {
        return String(valor || "").trim() || null;
      }

      return valor === null || valor === undefined || valor === ""
        ? null
        : valor;
    },
    atividadeStatusLabel(status) {
      const labels = {
        aberta: "Aberta",
        concluida: "Concluída",
        adiada: "Adiada",
        cancelada: "Cancelada",
      };

      return labels[status] || status || "-";
    },
    solicitacaoTecnicaStatusLabel(status) {
      const labels = {
        solicitada: "Aguardando técnico",
        link_enviado: "Aguardando cliente agendar",
        agendada: "Agendada",
        concluida: "Concluída",
        cancelada: "Cancelada",
      };

      return labels[status] || status || "-";
    },
    solicitacaoTecnicaFinalizada(solicitacao) {
      return ["concluida", "cancelada"].includes(solicitacao?.status);
    },
    agendaStatusLabel(status) {
      const labels = {
        agendado: "Agendado",
        confirmado: "Confirmado",
        concluido: "Concluído",
        realizado: "Realizado",
        cancelado: "Cancelado",
        nao_compareceu: "Não compareceu",
      };

      return labels[status] || status || "-";
    },
    agendaStatusFinal(status) {
      return ["concluido", "realizado", "cancelado", "nao_compareceu"].includes(
        status
      );
    },
    tarefaTemAgendaAtiva(tarefa) {
      return (
        !!tarefa?.agenda_ativa_id_crm_agenda ||
        this.booleanFlag(tarefa?.tarefa_agendada)
      );
    },
    agendaAtivaDaTarefa(tarefa) {
      const idAgenda = tarefa?.agenda_ativa_id_crm_agenda;

      if (!idAgenda) {
        return null;
      }

      const agendaCarregada = this.agendas.find(
        (agenda) => Number(agenda.id_crm_agenda) === Number(idAgenda)
      );

      if (agendaCarregada) {
        return agendaCarregada;
      }

      return {
        id_crm_agenda: idAgenda,
        id_crm_atividade: tarefa.id_crm_atividade,
        id_usuario: tarefa.agenda_ativa_id_usuario || tarefa.id_usuario,
        data_inicio: tarefa.agenda_ativa_data_inicio || tarefa.vencimento_em,
        duracao_minutos: tarefa.agenda_ativa_duracao_minutos || 30,
        status: "agendado",
        pode_reagendar: true,
      };
    },
    podeReagendarAgenda(agenda) {
      return (
        !this.agendaStatusFinal(agenda.status) &&
        agenda.pode_reagendar !== false
      );
    },
    podeCancelarAgenda(agenda) {
      return (
        !this.agendaStatusFinal(agenda.status) && agenda.pode_cancelar !== false
      );
    },
    podeConcluirAgenda(agenda) {
      return (
        !this.agendaStatusFinal(agenda.status) && agenda.pode_concluir !== false
      );
    },
    atividadeAtrasada(atividade) {
      return (
        atividade.status === "aberta" &&
        atividade.vencimento_em &&
        new Date(atividade.vencimento_em) < new Date()
      );
    },
    statusLabel(status) {
      const labels = {
        aberta: "Aberta",
        ganha: "Ganha",
        perdida: "Perdida",
      };

      return labels[status] || status || "-";
    },
    statusClass(status) {
      if (status === "ganha") {
        return "success";
      }

      if (status === "perdida") {
        return "danger";
      }

      return "primary";
    },
    agruparTimelinePorDia(items) {
      const grupos = [];
      const porChave = {};

      items.forEach((item) => {
        const data = item.created_at ? new Date(item.created_at) : new Date();
        const key = data.toISOString().slice(0, 10);
        const label = data.toLocaleDateString("pt-BR", {
          day: "2-digit",
          month: "long",
          year: "numeric",
        });

        if (!porChave[key]) {
          porChave[key] = {
            key,
            label,
            items: [],
          };
          grupos.push(porChave[key]);
        }

        porChave[key].items.push(item);
      });

      return grupos;
    },
    timelineCategoriaEvento(tipo) {
      const grupos = {
        alteracoes: [
          "oportunidade_criada",
          "oportunidade_atualizada",
          "etapa_alterada",
          "responsavel_alterado",
          "vendedor_responsavel_definido",
          "responsavel_tecnico_definido",
          "pessoa_atualizada_fechamento",
          "oportunidade_ganha",
          "oportunidade_perdida",
          "contrato_criado",
          "contrato_assinado",
          "implementacao_criada",
          "implementacao_finalizada",
          "treinamento_criado",
          "treinamento_concluido",
          "treinamento_finalizado",
          "website_criado",
          "website_pronto",
          "website_finalizado",
          "pos_venda_criado",
          "automacao_sucesso",
          "automacao_erro",
          "automacao_ignorada",
          "automacao_executada",
          "perda_registrada",
        ],
        notas: ["nota", "nota_adicionada"],
        anexos: ["anexo_adicionado"],
        tarefas: [
          "atividade_criada",
          "atividade_concluida",
          "atividade_adiada",
          "atividade_lembrete_adiado",
        ],
        agenda: [
          "crm_agenda_criada",
          "crm_agenda_atualizada",
          "crm_agenda_reagendada",
          "crm_agenda_cancelada",
          "crm_agenda_status",
          "agendamento_criado",
          "agendamento_atualizado",
          "agendamento_reagendado",
          "agendamento_cancelado",
          "agendamento_concluido",
          "agendamento_vinculado",
          "solicitacao_tecnica_criada",
          "solicitacao_tecnica_link_enviado",
          "solicitacao_tecnica_agendada",
          "solicitacao_tecnica_concluida",
          "treinamento_agendado",
          "website_agendado",
        ],
        contato: [
          "contato_criado",
          "contato_atualizado",
          "contato_vinculado_pessoa",
        ],
        whatsapp: ["whatsapp_enviado", "whatsapp_recebido", "whatsapp_aberto"],
      };

      return (
        Object.keys(grupos).find((categoria) =>
          grupos[categoria].includes(tipo)
        ) || "alteracoes"
      );
    },
    timelineCategoriaLabel(tipo) {
      const labels = {
        alteracoes: "Alterações",
        notas: "Notas",
        tarefas: "Tarefas",
        agenda: "Agenda",
        contato: "Contato",
        whatsapp: "WhatsApp",
        anexos: "Anexos",
      };

      return labels[this.timelineCategoriaEvento(tipo)] || "Evento";
    },
    timelineTitle(tipo) {
      const labels = {
        nota: "Nota adicionada",
        nota_adicionada: "Nota adicionada",
        anexo_adicionado: "Anexo adicionado",
        atividade_criada: "Tarefa criada",
        atividade_concluida: "Tarefa concluída",
        atividade_adiada: "Tarefa adiada",
        atividade_lembrete_adiado: "Lembrete adiado",
        crm_agenda_criada: "Agendamento criado",
        crm_agenda_atualizada: "Agendamento atualizado",
        crm_agenda_reagendada: "Agendamento reagendado",
        crm_agenda_cancelada: "Agendamento cancelado",
        crm_agenda_status: "Status do agendamento atualizado",
        agendamento_criado: "Agendamento operacional criado",
        agendamento_atualizado: "Agendamento operacional atualizado",
        agendamento_reagendado: "Agendamento operacional reagendado",
        agendamento_cancelado: "Agendamento operacional cancelado",
        agendamento_concluido: "Agendamento operacional concluído",
        agendamento_vinculado: "Agendamento vinculado",
        contato_criado: "Contato criado",
        contato_atualizado: "Contato atualizado",
        contato_vinculado_pessoa: "Contato associado a cliente",
        whatsapp_enviado: "WhatsApp enviado",
        whatsapp_recebido: "WhatsApp recebido",
        whatsapp_aberto: "WhatsApp aberto",
        etapa_alterada: "Etapa alterada",
        responsavel_alterado: "Responsável alterado",
        vendedor_responsavel_definido: "Vendedor responsável definido",
        responsavel_tecnico_definido: "Responsável técnico definido",
        pessoa_atualizada_fechamento: "Pessoa atualizada no fechamento",
        oportunidade_criada: "Oportunidade criada",
        oportunidade_atualizada: "Oportunidade atualizada",
        oportunidade_ganha: "Oportunidade ganha",
        oportunidade_perdida: "Oportunidade perdida",
        contrato_criado: "Contrato criado",
        contrato_assinado: "Contrato assinado",
        implementacao_criada: "Implementação criada",
        implementacao_finalizada: "Implementação finalizada",
        treinamento_criado: "Treinamento criado",
        treinamento_concluido: "Treinamento concluído",
        treinamento_agendado: "Treinamento agendado",
        treinamento_finalizado: "Treinamento finalizado",
        website_criado: "Website criado",
        website_pronto: "Website pronto",
        website_agendado: "Website agendado",
        website_finalizado: "Website finalizado",
        pos_venda_criado: "Pós-venda criado",
        solicitacao_tecnica_criada: "Solicitação técnica criada",
        solicitacao_tecnica_link_enviado: "Link de agenda técnica enviado",
        solicitacao_tecnica_agendada: "Agenda técnica agendada",
        solicitacao_tecnica_concluida: "Solicitação técnica concluída",
        automacao_sucesso: "Automação executada",
        automacao_erro: "Erro na automação",
        automacao_ignorada: "Automação ignorada",
        automacao_executada: "Automação executada",
        perda_registrada: "Perda registrada",
      };

      return labels[tipo] || tipo || "Evento";
    },
    timelineStatus(tipo) {
      const sucesso = [
        "oportunidade_ganha",
        "atividade_concluida",
        "crm_agenda_criada",
        "agendamento_concluido",
        "solicitacao_tecnica_agendada",
        "solicitacao_tecnica_concluida",
        "contrato_assinado",
        "implementacao_finalizada",
        "treinamento_agendado",
        "treinamento_concluido",
        "treinamento_finalizado",
        "website_agendado",
        "website_pronto",
        "website_finalizado",
        "pos_venda_criado",
        "pessoa_atualizada_fechamento",
        "automacao_sucesso",
        "automacao_executada",
      ];

      if (sucesso.indexOf(tipo) >= 0) {
        return "success";
      }

      const perigo = [
        "oportunidade_perdida",
        "crm_agenda_cancelada",
        "agendamento_cancelado",
        "automacao_erro",
        "perda_registrada",
      ];

      if (perigo.indexOf(tipo) >= 0) {
        return "danger";
      }

      const aviso = [
        "atividade_adiada",
        "atividade_lembrete_adiado",
        "crm_agenda_reagendada",
        "agendamento_reagendado",
        "solicitacao_tecnica_link_enviado",
        "automacao_ignorada",
      ];

      if (aviso.indexOf(tipo) >= 0) {
        return "warning";
      }

      return "";
    },
    formatMoney(value) {
      return Number(value || 0).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    },
    formatMoneyOrDash(value) {
      return value === null || value === undefined || value === ""
        ? "-"
        : this.formatMoney(value);
    },
    valorPrincipalOportunidade(oportunidade = {}) {
      const campos = [
        oportunidade.valor_principal,
        oportunidade.valor_final,
        oportunidade.valor_negociacao,
        oportunidade.valor_proposta,
        oportunidade.valor_estimado,
      ];
      const valor = campos.find(
        (item) => item !== null && item !== undefined && item !== ""
      );

      return Number(valor || 0);
    },
    valorCampoComercial(oportunidade = {}, chave) {
      if (!oportunidade) {
        return null;
      }

      if (oportunidade[chave] !== null && oportunidade[chave] !== undefined) {
        return oportunidade[chave];
      }

      const campos = Array.isArray(oportunidade.campos_comerciais)
        ? oportunidade.campos_comerciais
        : [];
      const campo = campos.find((item) => item.chave === chave);

      return campo && campo.valor !== "" && campo.valor !== null
        ? campo.valor
        : null;
    },
    somenteNumeros(value) {
      return String(value || "").replace(/\D+/g, "");
    },
    formatDate(value) {
      return value ? new Date(value).toLocaleDateString("pt-BR") : "-";
    },
    formatDateTime(value) {
      return value ? new Date(value).toLocaleString("pt-BR") : "-";
    },
    formatTime(value) {
      return new Date(value).toLocaleTimeString("pt-BR", {
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    toDateInput(value) {
      return value ? String(value).slice(0, 10) : null;
    },
    normalizarTelefoneWhatsapp(value) {
      let telefone = String(value || "").replace(/\D+/g, "");

      if (!telefone) {
        return "";
      }

      if (!telefone.startsWith("55") && telefone.length <= 11) {
        telefone = `55${telefone}`;
      }

      return telefone;
    },
    toDateTimeLocal(value) {
      if (!value) {
        return null;
      }

      const date = new Date(value);
      date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
      return date.toISOString().slice(0, 16);
    },
    fromDateTimeLocal(value) {
      return value ? value.replace("T", " ") + ":00" : null;
    },
    dateFromDateTimeLocal(value) {
      return value ? value.slice(0, 10) : null;
    },
    periodoAgendaDetalhe() {
      const inicio = new Date();
      inicio.setMonth(inicio.getMonth() - 6);

      const fim = new Date();
      fim.setMonth(fim.getMonth() + 12);

      return {
        data_inicio: this.dateOnly(inicio),
        data_fim: this.dateOnly(fim),
      };
    },
    periodoLinkSolicitacaoTecnica() {
      const inicio = new Date();
      const fim = new Date();
      fim.setDate(fim.getDate() + 7);

      return {
        data_inicio: this.dateOnly(inicio),
        data_fim: this.dateOnly(fim),
      };
    },
    dateOnly(date) {
      const normalized = new Date(date);
      normalized.setMinutes(
        normalized.getMinutes() - normalized.getTimezoneOffset()
      );
      return normalized.toISOString().slice(0, 10);
    },
    apiError(error, fallback) {
      return (
        error?.response?.data?.msg || error?.response?.data?.message || fallback
      );
    },
  },
};
